export const COLUMN_NAMES = {
  DO_IT: 'Do it',
  IN_PROGRESS: 'In Progress',
  AWAITING_REVIEW: 'Awaiting review',
  DONE: 'Done'
};

export const data = {
  jobData: [
    {
      id: 10,
      createdAt: '2024-07-30T16:34:57.825Z',
      updatedAt: '2024-09-24T18:13:18.329Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-26',
      endDate: '2024-08-26',
      startTime: 'Mon Aug 26 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 26 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724675400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 123,
      createdAt: '2024-09-26T09:44:30.845Z',
      updatedAt: '2024-09-29T05:00:56.579Z',
      licenseType: ['CNA', 'LPN', 'RN'],
      shiftTitle: 'CNA Morning Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-28',
      endDate: '2024-09-28',
      startTime: 'Sat Sep 28 2024 00:00:00 GMT-0500',
      endTime: 'Sat Sep 28 2024 23:59:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '23hours 59minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1727499600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 7,
      createdAt: '2024-07-30T16:34:57.432Z',
      updatedAt: '2024-09-24T08:29:14.838Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-04',
      endDate: '2024-08-04',
      startTime: 'Sun Aug 04 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 04 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Completed',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: 'Sun Aug 04 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      checkInFullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      checkInLatitude: '42.11548276970851',
      checkInLongitude: '-88.00356568029152',
      checkOutTime: 'Sun Aug 04 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      checkOutFullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      checkOutLatitude: '42.11548276970851',
      checkOutLongitude: '-88.00356568029152',
      checkOutMessage: 'Facility Approved',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: 'App Issue',
      noShowReasonAttachment: 'noShow/noShow-SFT-20240730-220457432.pdf',
      noShowComments: 'App is down ',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: 'App issue reason is accepted',
      pendingOrNoShowFacilityDecideStatus: true,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '9hours ',
      total_payment: '$9.00',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '1',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse:
        'Sun Aug 04 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse:
        'Sun Aug 04 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722781800000',
      noShowManagerReason: 'App Issue',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 8,
      createdAt: '2024-07-30T16:34:57.754Z',
      updatedAt: '2024-09-24T18:13:18.839Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-05',
      endDate: '2024-08-05',
      startTime: 'Mon Aug 05 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 05 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722861000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 9,
      createdAt: '2024-07-30T16:34:57.521Z',
      updatedAt: '2024-09-24T18:13:19.098Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-28',
      endDate: '2024-08-28',
      startTime: 'Wed Aug 28 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 28 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724848200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 22,
      createdAt: '2024-07-30T16:34:58.110Z',
      updatedAt: '2024-09-24T18:13:19.615Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-02',
      endDate: '2024-08-02',
      startTime: 'Fri Aug 02 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 02 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '5 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722601800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 28,
      createdAt: '2024-07-30T16:34:58.224Z',
      updatedAt: '2024-09-24T18:13:19.875Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Sarah Woods LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-10',
      endDate: '2024-08-10',
      startTime: 'Sat Aug 10 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 10 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '41eeec85-6916-43b6-a309-9048daa8751c',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['41eeec85-6916-43b6-a309-9048daa8751c'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723300200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 36,
      createdAt: '2024-07-30T16:34:58.386Z',
      updatedAt: '2024-09-24T18:13:20.134Z',
      licenseType: ['HHA'],
      shiftTitle: 'Mark Roeder-Aleks Przeslica CNA-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-11',
      endDate: '2024-08-11',
      startTime: 'Sun Aug 11 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 11 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '79218aea-254f-4ec5-87a9-a673ccab665c',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['79218aea-254f-4ec5-87a9-a673ccab665c'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723386600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 31,
      createdAt: '2024-07-30T16:34:58.308Z',
      updatedAt: '2024-09-24T18:13:20.396Z',
      licenseType: ['HHA'],
      shiftTitle: 'Mark Roeder-Aleks Przeslica CNA-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-17',
      endDate: '2024-08-17',
      startTime: 'Sat Aug 17 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 17 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '79218aea-254f-4ec5-87a9-a673ccab665c',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['79218aea-254f-4ec5-87a9-a673ccab665c'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723905000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 16,
      createdAt: '2024-07-30T16:34:57.995Z',
      updatedAt: '2024-09-24T18:13:20.916Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-22',
      endDate: '2024-08-22',
      startTime: 'Thu Aug 22 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 22 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724329800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 19,
      createdAt: '2024-07-30T16:34:58.053Z',
      updatedAt: '2024-09-24T18:13:21.175Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Meta Trybyte RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-27',
      endDate: '2024-08-27',
      startTime: 'Tue Aug 27 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 27 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724761800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 34,
      createdAt: '2024-07-30T16:34:58.349Z',
      updatedAt: '2024-09-24T18:13:21.432Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-29',
      endDate: '2024-08-29',
      startTime: 'Thu Aug 29 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 29 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724934600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 25,
      createdAt: '2024-07-30T16:34:58.166Z',
      updatedAt: '2024-09-24T18:13:19.356Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-01',
      endDate: '2024-08-01',
      startTime: 'Thu Aug 01 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 01 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722515400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 124,
      createdAt: '2024-09-27T05:22:38.971Z',
      updatedAt: '2024-09-27T05:29:16.459Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-10',
      endDate: '2024-10-10',
      startTime: 'Thu Oct 10 2024 07:00:00 GMT-0500',
      endTime: 'Thu Oct 10 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'ebc161f7-825f-4e48-bf5c-06de4274ee1a',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ebc161f7-825f-4e48-bf5c-06de4274ee1a'],
      jobRequestedNurses: [
        {
          id: 'ebc161f7-825f-4e48-bf5c-06de4274ee1a',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728561600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 10,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 17,
      createdAt: '2024-07-30T16:34:58.006Z',
      updatedAt: '2024-09-24T18:13:21.952Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Meta Trybyte RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-13',
      endDate: '2024-08-13',
      startTime: 'Tue Aug 13 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 13 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'a227e571-18b5-4424-a777-7562e4bb3736',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['a227e571-18b5-4424-a777-7562e4bb3736'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723552200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 24,
      createdAt: '2024-07-30T16:34:58.155Z',
      updatedAt: '2024-09-24T18:13:22.211Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-14',
      endDate: '2024-08-14',
      startTime: 'Wed Aug 14 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 14 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723638600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 18,
      createdAt: '2024-07-30T16:34:58.035Z',
      updatedAt: '2024-09-24T18:13:22.480Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-15',
      endDate: '2024-08-15',
      startTime: 'Thu Aug 15 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 15 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723725000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 27,
      createdAt: '2024-07-30T16:34:58.211Z',
      updatedAt: '2024-09-24T18:13:22.743Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-16',
      endDate: '2024-08-16',
      startTime: 'Fri Aug 16 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 16 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723811400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 12,
      createdAt: '2024-07-30T16:34:57.894Z',
      updatedAt: '2024-09-24T18:13:23.010Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-19',
      endDate: '2024-08-19',
      startTime: 'Mon Aug 19 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 19 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724070600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 14,
      createdAt: '2024-07-30T16:34:57.635Z',
      updatedAt: '2024-09-24T18:13:23.270Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Meta Trybyte RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-20',
      endDate: '2024-08-20',
      startTime: 'Tue Aug 20 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 20 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724157000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 23,
      createdAt: '2024-07-30T16:34:58.131Z',
      updatedAt: '2024-09-24T18:13:23.792Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-30',
      endDate: '2024-08-30',
      startTime: 'Fri Aug 30 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 30 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725021000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 21,
      createdAt: '2024-07-30T16:34:58.100Z',
      updatedAt: '2024-09-24T18:13:21.692Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-08',
      endDate: '2024-08-08',
      startTime: 'Thu Aug 08 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 08 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723120200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 32,
      createdAt: '2024-07-30T16:34:58.309Z',
      updatedAt: '2024-09-24T18:13:24.316Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-09',
      endDate: '2024-08-09',
      startTime: 'Fri Aug 09 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 09 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '5 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723206600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 47,
      createdAt: '2024-07-30T16:34:58.960Z',
      updatedAt: '2024-09-24T18:13:24.575Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-25',
      endDate: '2024-08-25',
      startTime: 'Sun Aug 25 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 25 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724637600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 37,
      createdAt: '2024-07-30T16:34:58.404Z',
      updatedAt: '2024-09-24T18:13:24.834Z',
      licenseType: ['HHA'],
      shiftTitle: 'Mark Roeder-Aleks Przeslica CNA-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-18',
      endDate: '2024-08-18',
      startTime: 'Sun Aug 18 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 18 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '79218aea-254f-4ec5-87a9-a673ccab665c',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['79218aea-254f-4ec5-87a9-a673ccab665c'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723991400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 43,
      createdAt: '2024-07-30T16:34:58.832Z',
      updatedAt: '2024-09-24T18:13:25.093Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-19',
      endDate: '2024-08-19',
      startTime: 'Mon Aug 19 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 19 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724074200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 35,
      createdAt: '2024-07-30T16:34:58.360Z',
      updatedAt: '2024-09-24T18:13:25.354Z',
      licenseType: ['HHA'],
      shiftTitle: 'Mark Roeder-Aleks Przeslica CNA-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-24',
      endDate: '2024-08-24',
      startTime: 'Sat Aug 24 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 24 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '79218aea-254f-4ec5-87a9-a673ccab665c',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['79218aea-254f-4ec5-87a9-a673ccab665c'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724509800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 41,
      createdAt: '2024-07-30T16:34:58.707Z',
      updatedAt: '2024-09-24T18:13:25.880Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-26',
      endDate: '2024-08-26',
      startTime: 'Mon Aug 26 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 26 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724679000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 42,
      createdAt: '2024-07-30T16:34:58.764Z',
      updatedAt: '2024-09-24T18:13:26.144Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-31',
      endDate: '2024-08-31',
      startTime: 'Sat Aug 31 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 31 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725156000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 48,
      createdAt: '2024-07-30T16:34:59.002Z',
      updatedAt: '2024-09-24T18:13:24.055Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-13',
      endDate: '2024-08-13',
      startTime: 'Tue Aug 13 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 13 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723600800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 50,
      createdAt: '2024-07-30T16:34:59.069Z',
      updatedAt: '2024-09-24T18:13:26.665Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-15',
      endDate: '2024-08-15',
      startTime: 'Thu Aug 15 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 15 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723773600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 33,
      createdAt: '2024-07-30T16:34:58.333Z',
      updatedAt: '2024-09-24T18:13:27.186Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-12',
      endDate: '2024-08-12',
      startTime: 'Mon Aug 12 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 12 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723465800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 45,
      createdAt: '2024-07-30T16:34:58.891Z',
      updatedAt: '2024-09-24T18:13:27.451Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-20',
      endDate: '2024-08-20',
      startTime: 'Tue Aug 20 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 20 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724205600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 46,
      createdAt: '2024-07-30T16:34:58.946Z',
      updatedAt: '2024-09-24T18:13:27.714Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-22',
      endDate: '2024-08-22',
      startTime: 'Thu Aug 22 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 22 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724378400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 44,
      createdAt: '2024-07-30T16:34:58.836Z',
      updatedAt: '2024-09-24T18:13:27.977Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-21',
      endDate: '2024-08-21',
      startTime: 'Wed Aug 21 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 21 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724247000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 30,
      createdAt: '2024-07-30T16:34:58.280Z',
      updatedAt: '2024-09-24T18:13:28.240Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-23',
      endDate: '2024-08-23',
      startTime: 'Fri Aug 23 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 23 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724416200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 55,
      createdAt: '2024-07-30T16:34:59.233Z',
      updatedAt: '2024-09-24T18:13:28.501Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-03',
      endDate: '2024-08-03',
      startTime: 'Sat Aug 03 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 03 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722736800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 38,
      createdAt: '2024-07-30T16:34:58.413Z',
      updatedAt: '2024-09-24T18:13:26.405Z',
      licenseType: ['RN', 'CNA'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-04',
      endDate: '2024-08-04',
      startTime: 'Sun Aug 04 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 04 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722823200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 59,
      createdAt: '2024-07-30T16:34:59.397Z',
      updatedAt: '2024-09-24T18:13:29.020Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-10',
      endDate: '2024-08-10',
      startTime: 'Sat Aug 10 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 10 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723341600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 58,
      createdAt: '2024-07-30T16:34:59.342Z',
      updatedAt: '2024-09-24T18:13:29.286Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-07',
      endDate: '2024-08-07',
      startTime: 'Wed Aug 07 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 07 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723037400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 67,
      createdAt: '2024-07-30T16:34:59.707Z',
      updatedAt: '2024-09-24T18:13:29.547Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-11',
      endDate: '2024-08-11',
      startTime: 'Sun Aug 11 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 11 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723428000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 66,
      createdAt: '2024-07-30T16:34:59.654Z',
      updatedAt: '2024-09-24T18:13:29.807Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Monica Cardenas LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-24',
      endDate: '2024-08-24',
      startTime: 'Sat Aug 24 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 24 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'c5bd5a08-282e-4843-b800-c350314d307b',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['c5bd5a08-282e-4843-b800-c350314d307b'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724551200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 64,
      createdAt: '2024-07-30T16:34:59.560Z',
      updatedAt: '2024-09-24T18:13:30.067Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-12',
      endDate: '2024-08-12',
      startTime: 'Mon Aug 12 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 12 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723469400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 61,
      createdAt: '2024-07-30T16:34:59.489Z',
      updatedAt: '2024-09-24T18:13:30.609Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Jessica Garibo LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-23',
      endDate: '2024-08-23',
      startTime: 'Fri Aug 23 2024 10:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 23 2024 13:00:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f98151fd-35d1-4c76-8f10-041c6a5b1e1d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f98151fd-35d1-4c76-8f10-041c6a5b1e1d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '3 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724425200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 65,
      createdAt: '2024-07-30T16:34:59.615Z',
      updatedAt: '2024-09-24T18:13:30.869Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-29',
      endDate: '2024-08-29',
      startTime: 'Thu Aug 29 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 29 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724983200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 60,
      createdAt: '2024-07-30T16:34:59.437Z',
      updatedAt: '2024-09-24T18:13:28.760Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-06',
      endDate: '2024-08-06',
      startTime: 'Tue Aug 06 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 06 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722996000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 128,
      createdAt: '2024-09-28T14:04:47.753Z',
      updatedAt: '2024-09-28T14:04:47.753Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-03',
      endDate: '2024-10-03',
      startTime: 'Thu Oct 03 2024 07:00:00 GMT-0500',
      endTime: 'Thu Oct 03 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f138d478-11df-43d4-b1c4-57f0e6f11645'],
      jobRequestedNurses: [
        {
          id: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1727956800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 62,
      createdAt: '2024-07-30T16:34:59.506Z',
      updatedAt: '2024-09-24T18:13:31.387Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-17',
      endDate: '2024-08-17',
      startTime: 'Sat Aug 17 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 17 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723946400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 57,
      createdAt: '2024-07-30T16:34:59.329Z',
      updatedAt: '2024-09-24T18:13:31.648Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Jessica Garibo LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-16',
      endDate: '2024-08-16',
      startTime: 'Fri Aug 16 2024 10:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 16 2024 13:00:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f98151fd-35d1-4c76-8f10-041c6a5b1e1d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f98151fd-35d1-4c76-8f10-041c6a5b1e1d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '3 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723820400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 68,
      createdAt: '2024-07-30T16:34:59.724Z',
      updatedAt: '2024-09-24T18:13:31.910Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-18',
      endDate: '2024-08-18',
      startTime: 'Sun Aug 18 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 18 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724032800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 56,
      createdAt: '2024-07-30T16:34:59.288Z',
      updatedAt: '2024-09-24T18:13:32.169Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Jessica Garibo LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-30',
      endDate: '2024-08-30',
      startTime: 'Fri Aug 30 2024 10:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 30 2024 13:00:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f98151fd-35d1-4c76-8f10-041c6a5b1e1d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f98151fd-35d1-4c76-8f10-041c6a5b1e1d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '3 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725030000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 51,
      createdAt: '2024-07-30T16:34:59.111Z',
      updatedAt: '2024-09-24T18:13:32.430Z',
      licenseType: [null, 'RN'],
      shiftTitle: 'Mark Roeder-Antonina Kawecki LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-02',
      endDate: '2024-08-02',
      startTime: 'Fri Aug 02 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 02 2024 16:00:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '94c28a78-8791-47dc-ac53-e7f2c7ecd74e',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['94c28a78-8791-47dc-ac53-e7f2c7ecd74e'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722601800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 20,
      createdAt: '2024-07-30T16:34:58.073Z',
      updatedAt: '2024-09-24T18:13:31.127Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder--Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-03',
      endDate: '2024-08-03',
      startTime: 'Sat Aug 03 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 03 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722695400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 129,
      createdAt: '2024-09-30T08:26:25.537Z',
      updatedAt: '2024-09-30T08:26:25.537Z',
      licenseType: ['CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-08',
      endDate: '2024-10-08',
      startTime: 'Tue Oct 08 2024 07:00:00 GMT-0500',
      endTime: 'Tue Oct 08 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'db182811-3217-4944-8d0a-4ad31a9f8289',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['db182811-3217-4944-8d0a-4ad31a9f8289'],
      jobRequestedNurses: [
        {
          id: 'db182811-3217-4944-8d0a-4ad31a9f8289',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728388800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 29,
      createdAt: '2024-07-30T16:34:58.265Z',
      updatedAt: '2024-09-24T18:13:33.198Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Meta Trybyte RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-06',
      endDate: '2024-08-06',
      startTime: 'Tue Aug 06 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 06 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722947400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 82,
      createdAt: '2024-08-13T07:18:25.482Z',
      updatedAt: '2024-09-24T18:13:32.940Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-28',
      endDate: '2024-08-28',
      startTime: 'Wed Aug 28 2024 07:00:00 GMT-0500',
      endTime: 'Wed Aug 28 2024 15:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: 'Testing from nurse profile',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724846400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 79,
      createdAt: '2024-08-06T16:36:20.383Z',
      updatedAt: '2024-09-24T18:13:33.458Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: 'Advanced Practice',
      certification: ['ACLS'],
      yearOfExperience: '0 - 1 year ',
      expiration: '0',
      startDate: '2024-08-12',
      endDate: '2024-08-12',
      startTime: 'Mon Aug 12 2024 10:00:00 GMT-0500',
      endTime: 'Mon Aug 12 2024 18:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: ['ABELMed'],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723474800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 40,
      createdAt: '2024-07-30T16:34:58.704Z',
      updatedAt: '2024-09-24T18:13:33.718Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-28',
      endDate: '2024-08-28',
      startTime: 'Wed Aug 28 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 28 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724851800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 83,
      createdAt: '2024-08-14T08:46:06.669Z',
      updatedAt: '2024-09-24T18:13:33.976Z',
      licenseType: ['LPN', 'CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-05',
      endDate: '2024-09-05',
      startTime: '2024-09-05T12:00:00.000Z',
      endTime: '2024-09-05T20:00:00.000Z',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '493fdea5-1d8e-4ea0-9d9f-6ffd08f4f540',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['493fdea5-1d8e-4ea0-9d9f-6ffd08f4f540'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725537600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 88,
      createdAt: '2024-09-11T09:38:28.976Z',
      updatedAt: '2024-09-24T18:13:34.495Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-13',
      endDate: '2024-09-13',
      startTime: 'Fri Sep 13 2024 07:30:00 GMT-0500',
      endTime: 'Fri Sep 13 2024 15:30:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: 'Morning',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726230600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 91,
      createdAt: '2024-09-12T15:23:43.790Z',
      updatedAt: '2024-09-24T18:13:35.014Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-14',
      endDate: '2024-09-14',
      startTime: 'Sat Sep 14 2024 07:00:00 GMT-0500',
      endTime: 'Sat Sep 14 2024 15:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: 'Morning',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '25405344-d958-4c82-8d7c-a85f5e8b47fc',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['25405344-d958-4c82-8d7c-a85f5e8b47fc'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: true,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726315200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 92,
      createdAt: '2024-09-12T15:53:20.559Z',
      updatedAt: '2024-09-24T18:13:35.274Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-14',
      endDate: '2024-09-14',
      startTime: 'Sat Sep 14 2024 07:00:00 GMT-0500',
      endTime: 'Sat Sep 14 2024 15:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: 'Morning',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '39904aab-4b50-4687-8ad9-d889612f2c0d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['39904aab-4b50-4687-8ad9-d889612f2c0d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: true,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726315200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 94,
      createdAt: '2024-09-16T23:29:08.728Z',
      updatedAt: '2024-09-24T18:13:35.531Z',
      licenseType: ['RN'],
      shiftTitle: 'RN Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-19',
      endDate: '2024-09-19',
      startTime: 'Thu Sep 19 2024 00:00:00 GMT-0500',
      endTime: 'Thu Sep 19 2024 23:59:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'd2d993d0-8303-4534-9f85-6a486b7ab445',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['d2d993d0-8303-4534-9f85-6a486b7ab445'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '23hours 59minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726722000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 90,
      createdAt: '2024-09-11T13:38:12.343Z',
      updatedAt: '2024-09-24T18:13:35.788Z',
      licenseType: ['RN'],
      shiftTitle: 'RN Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-18',
      endDate: '2024-09-18',
      startTime: 'Wed Sep 18 2024 00:00:00 GMT-0500',
      endTime: 'Wed Sep 18 2024 23:59:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '23hours 59minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726635600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 93,
      createdAt: '2024-09-13T12:49:07.966Z',
      updatedAt: '2024-09-24T18:13:36.047Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-14',
      endDate: '2024-09-14',
      startTime: 'Sat Sep 14 2024 07:30:00 GMT-0500',
      endTime: 'Sat Sep 14 2024 15:30:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: 'Morning',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '1e80ad4b-4591-4b45-b3ed-6a7d05d00ce9',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['1e80ad4b-4591-4b45-b3ed-6a7d05d00ce9'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726317000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 95,
      createdAt: '2024-09-17T14:59:01.676Z',
      updatedAt: '2024-09-24T18:13:36.306Z',
      licenseType: ['LPN', 'CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-20',
      endDate: '2024-09-20',
      startTime: 'Fri Sep 20 2024 07:00:00 GMT-0500',
      endTime: 'Fri Sep 20 2024 15:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'd0a8fac9-3967-4e85-bf28-fe7e7611b0bf',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['d0a8fac9-3967-4e85-bf28-fe7e7611b0bf'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726833600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 89,
      createdAt: '2024-09-11T09:59:24.625Z',
      updatedAt: '2024-09-24T18:13:34.754Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-14',
      endDate: '2024-09-14',
      startTime: 'Sat Sep 14 2024 07:00:00 GMT-0500',
      endTime: 'Sat Sep 14 2024 15:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: 'Morning',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: true,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726315200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 132,
      createdAt: '2024-09-30T08:40:14.792Z',
      updatedAt: '2024-09-30T08:40:14.792Z',
      licenseType: ['CNA', 'RN'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-16',
      endDate: '2024-10-16',
      startTime: 'Wed Oct 16 2024 07:00:00 GMT-0500',
      endTime: 'Wed Oct 16 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'db182811-3217-4944-8d0a-4ad31a9f8289',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['db182811-3217-4944-8d0a-4ad31a9f8289'],
      jobRequestedNurses: [
        {
          id: 'db182811-3217-4944-8d0a-4ad31a9f8289',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '2',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '2',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1729080000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 133,
      createdAt: '2024-09-30T08:43:10.316Z',
      updatedAt: '2024-09-30T08:43:10.316Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-15',
      endDate: '2024-10-15',
      startTime: 'Tue Oct 15 2024 07:00:00 GMT-0500',
      endTime: 'Tue Oct 15 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [
        {
          id: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728993600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 96,
      createdAt: '2024-09-17T15:00:16.031Z',
      updatedAt: '2024-09-24T18:13:36.565Z',
      licenseType: ['LPN', 'CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-20',
      endDate: '2024-09-20',
      startTime: 'Fri Sep 20 2024 07:00:00 GMT-0500',
      endTime: 'Fri Sep 20 2024 15:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1726833600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 134,
      createdAt: '2024-09-30T08:48:35.616Z',
      updatedAt: '2024-09-30T08:48:35.616Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-18',
      endDate: '2024-10-18',
      startTime: 'Fri Oct 18 2024 07:00:00 GMT-0500',
      endTime: 'Fri Oct 18 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [
        {
          id: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1729252800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 119,
      createdAt: '2024-09-23T08:41:25.020Z',
      updatedAt: '2024-09-30T09:06:28.455Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-08',
      endDate: '2024-10-08',
      startTime: 'Tue Oct 08 2024 07:00:00 GMT-0500',
      endTime: 'Tue Oct 08 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f138d478-11df-43d4-b1c4-57f0e6f11645'],
      jobRequestedNurses: [
        {
          id: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728388800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 120,
      createdAt: '2024-09-23T08:41:27.765Z',
      updatedAt: '2024-09-30T09:53:40.187Z',
      licenseType: ['LPN', 'CNA', 'RN'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-09',
      endDate: '2024-10-09',
      startTime: 'Wed Oct 09 2024 17:30:00 GMT+0530',
      endTime: 'Wed Oct 09 2024 05:30:00 GMT+0530',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '8c33f97e-34ce-4225-b02d-2381bd8b5e80',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['8c33f97e-34ce-4225-b02d-2381bd8b5e80'],
      jobRequestedNurses: [
        {
          id: '8c33f97e-34ce-4225-b02d-2381bd8b5e80',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hour ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728412200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 11,
      createdAt: '2024-07-30T16:34:57.880Z',
      updatedAt: '2024-09-24T18:13:36.826Z',
      licenseType: ['HHA'],
      shiftTitle: 'Mark Roeder-Aleks Przeslica CNA-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-31',
      endDate: '2024-08-31',
      startTime: 'Sat Aug 31 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sat Aug 31 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f138d478-11df-43d4-b1c4-57f0e6f11645'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: 'Swap Testing',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725114600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 121,
      createdAt: '2024-09-23T08:41:30.515Z',
      updatedAt: '2024-09-25T08:27:20.836Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-10',
      endDate: '2024-10-10',
      startTime: 'Thu Oct 10 2024 07:00:00 GMT-0500',
      endTime: 'Thu Oct 10 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [
        {
          id: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728561600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 26,
      createdAt: '2024-07-30T16:34:58.186Z',
      updatedAt: '2024-09-24T18:13:37.085Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-07',
      endDate: '2024-08-07',
      startTime: 'Wed Aug 07 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 07 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723033800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 122,
      createdAt: '2024-09-24T09:22:59.170Z',
      updatedAt: '2024-09-24T18:16:56.210Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-05',
      endDate: '2024-10-05',
      startTime: 'Sat Oct 05 2024 07:00:00 GMT-0500',
      endTime: 'Sat Oct 05 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'db182811-3217-4944-8d0a-4ad31a9f8289',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['db182811-3217-4944-8d0a-4ad31a9f8289'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: 'Testing',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728129600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 13,
      createdAt: '2024-07-30T16:34:57.936Z',
      updatedAt: '2024-09-24T18:13:20.654Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Maria Laureano LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-21',
      endDate: '2024-08-21',
      startTime: 'Wed Aug 21 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 21 2024 19:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['ecf1979a-a81a-44b6-97ff-2b7f0056c726'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724243400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 15,
      createdAt: '2024-07-30T16:34:57.950Z',
      updatedAt: '2024-09-24T18:13:23.531Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-25',
      endDate: '2024-08-25',
      startTime: 'Sun Aug 25 2024 09:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Sun Aug 25 2024 18:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724596200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 52,
      createdAt: '2024-07-30T16:34:59.128Z',
      updatedAt: '2024-09-24T18:13:25.616Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-27',
      endDate: '2024-08-27',
      startTime: 'Tue Aug 27 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Tue Aug 27 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724810400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 49,
      createdAt: '2024-07-30T16:34:59.054Z',
      updatedAt: '2024-09-24T18:13:37.342Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-08',
      endDate: '2024-08-08',
      startTime: 'Thu Aug 08 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 08 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723168800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 54,
      createdAt: '2024-07-30T16:34:59.218Z',
      updatedAt: '2024-09-24T18:13:37.603Z',
      licenseType: ['LPN', 'RN'],
      shiftTitle: 'Mark Roeder-Ira Guenther RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-01',
      endDate: '2024-08-01',
      startTime: 'Thu Aug 01 2024 21:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Thu Aug 01 2024 05:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f7faf662-f9ee-4086-87ee-9a663ac0006f'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Night',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722564000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 63,
      createdAt: '2024-07-30T16:34:59.546Z',
      updatedAt: '2024-09-24T18:13:37.861Z',
      licenseType: ['LPN'],
      shiftTitle: 'Mark Roeder-Jessica Garibo LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-09',
      endDate: '2024-08-09',
      startTime: 'Fri Aug 09 2024 10:00:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Fri Aug 09 2024 13:00:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: 'f98151fd-35d1-4c76-8f10-041c6a5b1e1d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f98151fd-35d1-4c76-8f10-041c6a5b1e1d'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '3 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723215600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 39,
      createdAt: '2024-07-30T16:34:58.611Z',
      updatedAt: '2024-09-24T18:13:26.925Z',
      licenseType: [null, 'RN'],
      shiftTitle: 'Mark Roeder-Antonina Kawecki LPN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-05',
      endDate: '2024-08-05',
      startTime: 'Mon Aug 05 2024 07:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Mon Aug 05 2024 16:00:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8 hours 30 minutes',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1722861000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 53,
      createdAt: '2024-07-30T16:34:59.166Z',
      updatedAt: '2024-09-24T18:13:30.329Z',
      licenseType: ['RN'],
      shiftTitle: 'Mark Roeder-Olga Orosciuc RN-Job Title',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-14',
      endDate: '2024-08-14',
      startTime: 'Wed Aug 14 2024 08:30:00 GMT-0500 (Central Daylight Time)',
      endTime: 'Wed Aug 14 2024 12:30:00 GMT-0500 (Central Daylight Time)',
      break: 'No Break',
      customerName: 'Mark Roeder',
      customerId: '2',
      unit: '',
      floor: '',
      fullAddress:
        '1607, Plymouth Drive, Arlington Heights, Wheeling Township, Cook County, Illinois, United States, 60004, 2848',
      latitude: '42.11548276970851',
      longitude: '-88.00356568029152',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['72709c1b-75f1-4950-99e2-a36afb1de0bd'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '4 hours',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723642200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 84,
      createdAt: '2024-08-14T10:24:12.604Z',
      updatedAt: '2024-09-24T18:13:34.234Z',
      licenseType: ['LPN', 'CNA', 'RN'],
      shiftTitle: 'CNA Morning',
      specialty: 'Administration',
      certification: ['ACLS', 'AWHONN'],
      yearOfExperience: '0 - 1 year ',
      expiration: '0',
      startDate: '2024-09-06',
      endDate: '2024-09-06',
      startTime: '2024-09-06T14:00:00.000Z',
      endTime: '2024-09-07T02:00:00.000Z',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '50',
      enableBid: false,
      notes: 'Test notes',
      jobType: 'Shift',
      jobStatus: 'Missed',
      jobFinalSelectionNurseId: '626a5431-5919-4469-a7b3-b2a659246406',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['626a5431-5919-4469-a7b3-b2a659246406'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: ['AllegianceMD', 'AdvancedMD'],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: true,
      experienceRequired: false,
      emrehrRequired: true,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725624000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 136,
      createdAt: '2024-09-30T10:04:54.151Z',
      updatedAt: '2024-09-30T10:06:57.770Z',
      licenseType: ['CNA', 'LPN', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-27',
      endDate: '2024-10-27',
      startTime: 'Sun Oct 27 2024 07:00:00 GMT+0530',
      endTime: 'Sun Oct 27 2024 19:00:00 GMT+0530',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f138d478-11df-43d4-b1c4-57f0e6f11645'],
      jobRequestedNurses: [
        {
          id: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1729967400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 135,
      createdAt: '2024-09-30T10:01:49.274Z',
      updatedAt: '2024-09-30T10:16:24.473Z',
      licenseType: ['CNA', 'LPN', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-20',
      endDate: '2024-10-20',
      startTime: 'Sun Oct 20 2024 07:00:00 GMT+0530',
      endTime: 'Sun Oct 20 2024 19:00:00 GMT+0530',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '8c33f97e-34ce-4225-b02d-2381bd8b5e80',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['8c33f97e-34ce-4225-b02d-2381bd8b5e80'],
      jobRequestedNurses: [
        {
          id: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: 'Testing ',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1729362600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 125,
      createdAt: '2024-09-28T13:16:17.814Z',
      updatedAt: '2024-10-02T10:01:19.905Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-02',
      endDate: '2024-10-02',
      startTime: 'Wed Oct 02 2024 07:00:00 GMT-0500',
      endTime: 'Wed Oct 02 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '8c33f97e-34ce-4225-b02d-2381bd8b5e80',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['8c33f97e-34ce-4225-b02d-2381bd8b5e80'],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1727870400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 118,
      createdAt: '2024-09-23T08:41:22.284Z',
      updatedAt: '2024-09-27T13:18:22.900Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-07',
      endDate: '2024-10-07',
      startTime: 'Mon Oct 07 2024 07:00:00 GMT-0500',
      endTime: 'Mon Oct 07 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Pending Assignment',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [
        {
          id: '39904aab-4b50-4687-8ad9-d889612f2c0d',
          type: 'Floating Pool'
        },
        {
          id: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Internal Pool'
        },
        {
          id: '20c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Agency'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728302400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: '',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: 'Rejected',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 117,
      createdAt: '2024-09-23T08:41:19.004Z',
      updatedAt: '2024-09-26T19:37:49.861Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-06',
      endDate: '2024-10-06',
      startTime: 'Sun Oct 06 2024 07:00:00 GMT-0500',
      endTime: 'Sun Oct 06 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['10c6d26b-9589-4a7e-a895-2485a2d1fa5d'],
      jobRequestedNurses: [
        {
          id: '20c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Agency'
        },
        {
          id: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Internal Pool'
        },
        {
          id: '39904aab-4b50-4687-8ad9-d889612f2c0d',
          type: 'Floating Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728216000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: 'Agency',
      jobSharedId: 2,
      jobSharedAction: 'Completed',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 115,
      createdAt: '2024-09-23T08:41:13.195Z',
      updatedAt: '2024-10-02T10:01:19.905Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-02',
      endDate: '2024-10-02',
      startTime: 'Wed Oct 02 2024 07:00:00 GMT-0500',
      endTime: 'Wed Oct 02 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Nurse Assigned',
      jobFinalSelectionNurseId: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
      jobBitFinalAmount: '',
      jobAcceptedNurses: ['f138d478-11df-43d4-b1c4-57f0e6f11645'],
      jobRequestedNurses: [
        {
          id: '20c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Agency'
        },
        {
          id: 'db182811-3217-4944-8d0a-4ad31a9f8289',
          type: 'Internal Pool'
        },
        {
          id: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
          type: 'Internal Pool'
        },
        {
          id: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Internal Pool'
        }
      ],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: 'Sent',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: [
        {
          nurseId: 'db182811-3217-4944-8d0a-4ad31a9f8289',
          nurseName: 'Dev Nurse',
          cancelNote: 'Testing'
        },
        {
          nurseId: 35,
          nurseName: 'Dev Nurse',
          cancelNote: 'Test'
        },
        {
          nurseId: 35,
          nurseName: 'Dev Nurse',
          cancelNote: 'Test'
        },
        {
          nurseId: 1,
          nurseName: 'Jason Smith',
          cancelNote: 'Testing agency release'
        },
        {
          nurseId: 1,
          nurseName: 'Jason Smith',
          cancelNote: ''
        },
        {
          nurseId: 1,
          nurseName: 'Jason Smith',
          cancelNote: ''
        },
        {
          nurseId: 1,
          nurseName: 'Jason Smith',
          cancelNote: ''
        }
      ],
      nurseSwapNotes: 'Testing ',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '1',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1727870400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: 'Agency',
      jobSharedId: 2,
      jobSharedAction: 'Completed',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 131,
      createdAt: '2024-09-30T08:37:51.579Z',
      updatedAt: '2024-09-30T08:37:51.579Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-05',
      endDate: '2024-10-05',
      startTime: 'Sat Oct 05 2024 07:00:00 GMT-0500',
      endTime: 'Sat Oct 05 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Open',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '2',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1728129600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 69,
      createdAt: '2024-08-06T15:59:23.884Z',
      updatedAt: '2024-08-15T12:01:51.389Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-15',
      endDate: '2024-08-15',
      startTime: 'Thu Aug 15 2024 07:00:00 GMT-0500',
      endTime: 'Thu Aug 15 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: true,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723723200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 71,
      createdAt: '2024-08-06T16:18:36.896Z',
      updatedAt: '2024-08-24T15:01:23.251Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: 'Administration',
      certification: ['ACLS'],
      yearOfExperience: '1 - 2 years',
      expiration: '0',
      startDate: '2024-08-24',
      endDate: '2024-08-24',
      startTime: 'Sat Aug 24 2024 10:00:00 GMT-0500',
      endTime: 'Sat Aug 24 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: ['ABELMed'],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724338800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 70,
      createdAt: '2024-08-06T16:18:36.888Z',
      updatedAt: '2024-08-22T15:02:37.863Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning',
      specialty: 'Administration',
      certification: ['ACLS'],
      yearOfExperience: '1 - 2 years',
      expiration: '0',
      startDate: '2024-08-22',
      endDate: '2024-08-22',
      startTime: 'Thu Aug 22 2024 10:00:00 GMT-0500',
      endTime: 'Thu Aug 22 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [1],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '9hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: ['ABELMed'],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1724338800000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 80,
      createdAt: '2024-08-11T17:50:47.931Z',
      updatedAt: '2024-08-17T05:00:53.746Z',
      licenseType: ['CNA'],
      shiftTitle: 'CNA Morning ',
      specialty: 'Administration',
      certification: ['APHN-BC'],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-17',
      endDate: '2024-08-17',
      startTime: 'Sat Aug 17 2024 07:00:00 GMT+0530',
      endTime: 'Sat Aug 17 2024 15:00:00 GMT+0530',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '50',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: ['ABELMed'],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723858200000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 81,
      createdAt: '2024-08-12T04:22:26.135Z',
      updatedAt: '2024-08-13T05:00:14.376Z',
      licenseType: ['CNA', 'HHA'],
      shiftTitle: 't',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-08-13',
      endDate: '2024-08-13',
      startTime: 'Tue Aug 13 2024 09:30:00 GMT+0530',
      endTime: 'Tue Aug 13 2024 11:30:00 GMT+0530',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '2hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1723521600000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 9,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 85,
      createdAt: '2024-08-14T10:24:15.043Z',
      updatedAt: '2024-09-07T12:00:09.459Z',
      licenseType: ['LPN', 'CNA', 'RN'],
      shiftTitle: 'CNA Morning',
      specialty: 'Administration',
      certification: ['ACLS', 'AWHONN'],
      yearOfExperience: '0 - 1 year ',
      expiration: '0',
      startDate: '2024-09-07',
      endDate: '2024-09-07',
      startTime: 'Sat Sep 07 2024 07:00:00 GMT-0500',
      endTime: 'Sat Sep 07 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '50',
      enableBid: false,
      notes: 'Test notes',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: ['AllegianceMD', 'AdvancedMD'],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: true,
      experienceRequired: false,
      emrehrRequired: true,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725710400000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 87,
      createdAt: '2024-09-04T08:50:49.241Z',
      updatedAt: '2024-09-06T12:00:49.077Z',
      licenseType: ['LPN', 'CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-06',
      endDate: '2024-09-06',
      startTime: '2024-09-06T12:00:00.000Z',
      endTime: '2024-09-06T20:00:00.000Z',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725624000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 86,
      createdAt: '2024-09-04T08:49:21.251Z',
      updatedAt: '2024-09-06T12:00:49.077Z',
      licenseType: ['LPN', 'CNA'],
      shiftTitle: 'CNA Morning',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-09-06',
      endDate: '2024-09-06',
      startTime: '2024-09-06T12:00:00.000Z',
      endTime: '2024-09-06T20:00:00.000Z',
      break: 'No Break',
      customerName: 'CHRISTINE KENNOY',
      customerId: '1',
      unit: '',
      floor: '',
      fullAddress:
        '2700, Point Lane, Highland Park, West Deerfield Township, Lake County, Illinois, United States, 60035, 1513',
      latitude: '42.2004060197085',
      longitude: '-87.8392211302915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [],
      autoAcceptedEnable: false,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '8hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1725624000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: '',
      jobSharedId: 0,
      jobSharedAction: '',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 114,
      createdAt: '2024-09-23T08:41:10.430Z',
      updatedAt: '2024-10-01T12:00:05.420Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-01',
      endDate: '2024-10-01',
      startTime: 'Tue Oct 01 2024 07:00:00 GMT-0500',
      endTime: 'Tue Oct 01 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [
        {
          id: '20c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Agency'
        }
      ],
      autoAcceptedEnable: true,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1727784000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: 'Agency',
      jobSharedId: 2,
      jobSharedAction: 'Completed',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    },
    {
      id: 500,
      createdAt: '2024-09-23T08:41:10.430Z',
      updatedAt: '2024-10-01T12:00:05.420Z',
      licenseType: ['LPN', 'CNA', 'RN', 'HHA'],
      shiftTitle: '7:00 AM - 7:00 PM Shift',
      specialty: '',
      certification: [],
      yearOfExperience: '',
      expiration: '0',
      startDate: '2024-10-01',
      endDate: '2024-10-01',
      startTime: 'Tue Oct 01 2024 07:00:00 GMT-0500',
      endTime: 'Tue Oct 01 2024 19:00:00 GMT-0500',
      break: 'No Break',
      customerName: 'Antonio Lewis',
      customerId: '12',
      unit: '',
      floor: '',
      fullAddress:
        '1764, East Oakton Street, Des Plaines, Maine Township, Cook County, Illinois, United States, 60018, 2162',
      latitude: '42.0231207197085',
      longitude: '-87.8817972802915',
      baseRate: '1',
      enableBid: false,
      notes: '',
      jobType: 'Shift',
      jobStatus: 'Unfulfilled',
      jobFinalSelectionNurseId: '',
      jobBitFinalAmount: '',
      jobAcceptedNurses: [],
      jobRequestedNurses: [
        {
          id: '20c6d26b-9589-4a7e-a895-2485a2d1fa5d',
          type: 'Agency'
        }
      ],
      autoAcceptedEnable: true,
      checkInTimeAlert: '',
      alertForClockIn: '',
      checkInTime: '',
      checkInFullAddress: '',
      checkInLatitude: '',
      checkInLongitude: '',
      checkOutTime: '',
      checkOutFullAddress: '',
      checkOutLatitude: '',
      checkOutLongitude: '',
      checkOutMessage: '',
      jobShiftTimingType: '',
      maxBidAmount: '',
      jobDuration: '12hours ',
      jobTiming: 'Morning',
      jobDays: '',
      EMRorEHRExperience: [],
      noShowReason: '',
      noShowReasonAttachment: '',
      noShowComments: '',
      neverCheckOutReason: '',
      neverCheckOutReasonAttachment: '',
      neverCheckOutComments: '',
      pendingOrNoShowFacilityDecideMessage: '',
      pendingOrNoShowFacilityDecideStatus: false,
      specialtyRequired: false,
      experienceRequired: false,
      emrehrRequired: false,
      certificationRequired: false,
      customerVisibility: false,
      worked_hours: '',
      total_payment: '',
      nurseCancelNotes: {},
      nurseSwapNotes: '',
      jobPostingTableFacilityTableId: '1',
      baseRateVisibility: false,
      manager_review_comments: '',
      approved_manager: '',
      closed_by: '',
      timeAdjustByNurse: false,
      timeAdjustByFacility: false,
      checkInTimeNurse: '',
      checkInFullAddressNurse: '',
      checkInLatitudeNurse: '',
      checkInLongitudeNurse: '',
      checkOutTimeNurse: '',
      checkOutFullAddressNurse: '',
      checkOutLatitudeNurse: '',
      checkOutLongitudeNurse: '',
      startDateTimeStamp: '1727784000000',
      noShowManagerReason: '',
      noShowManagerReasonAttachment: '',
      neverCheckOutManagerReason: '',
      neverCheckOutManagerReasonAttachment: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      jobCompletedBy: 'Internal Pool',
      jobCompletedAgencyId: 0,
      jobCompletedHospitalId: 0,
      jobOrderId: 0,
      jobSharedType: 'Agency',
      jobSharedId: 2,
      jobSharedAction: 'Completed',
      bidNurseArray: [],
      additionalFields: [],
      preStateAdditionalFields: []
    }
  ],
  nurseList: [
    {
      id: 3,
      uniqueId: '8c33f97e-34ce-4225-b02d-2381bd8b5e80',
      createdAt: '2024-02-01T18:57:29.473Z',
      updatedAt: '2024-04-11T18:17:11.283Z',
      emailId: 'victoria.nursd@yopmail.com',
      firstName: 'Victoria',
      lastName: 'Chan',
      password: '12345678',
      phoneNumber: '2143658663',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '1997-04-03T18:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-02-01T18:55:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1632,West Central Road,Arlington Heights,Wheeling Township,Cook County,Illinois,United States,60005,2407',
      latitude: '42.0669311',
      longitude: '-88.0021737',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 139,
          createdAt: '2024-02-01T18:57:29.574Z',
          updatedAt: '2024-02-01T18:57:29.574Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 3
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 4,
      uniqueId: 'f138d478-11df-43d4-b1c4-57f0e6f11645',
      createdAt: '2024-02-07T21:43:56.929Z',
      updatedAt: '2024-05-12T12:52:32.697Z',
      emailId: 'cherrylin@yopmail.com',
      firstName: 'Cherry',
      lastName: 'Lin',
      password: '12345678',
      phoneNumber: '2145632583',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2024-02-07T21:41:54.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'HHA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '7374774',
      clinicalLicenseExpirationDate: '2024-06-07T17:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7435,West Talcott Avenue,Norwood Park,Chicago,Cook County,Illinois,United States,60631',
      latitude: '41.9876791',
      longitude: '-87.8142891',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 140,
          createdAt: '2024-02-07T21:43:57.374Z',
          updatedAt: '2024-02-07T21:43:57.374Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 4
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 8,
      uniqueId: '5bb1c30b-c9e0-4fe5-9fd5-db239459eb86',
      createdAt: '2024-02-20T15:51:12.679Z',
      updatedAt: '2024-02-20T21:17:35.513Z',
      emailId: 'dsheri@yopmail.com',
      firstName: 'Doris',
      lastName: 'Sheridan',
      password: '12345678',
      phoneNumber: '8478326500',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2012-08-26T14:41:58.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: true,
      clinicalLicenseNumber: '7374774',
      clinicalLicenseExpirationDate: '2025-06-13T14:41:58.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '568, South Washington Street, Naperville, Naperville Township, DuPage County, Illinois, United States, 60540, 6843',
      latitude: '41.7665738697085',
      longitude: '-88.1494151802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: false,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 143,
          createdAt: '2024-02-20T15:51:13.148Z',
          updatedAt: '2024-02-20T15:51:13.148Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 8
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 9,
      uniqueId: '07855527-31c7-4ae2-9f69-5421468eb6ef',
      createdAt: '2024-02-20T15:58:50.399Z',
      updatedAt: '2024-03-18T15:52:25.200Z',
      emailId: 'cdenler@yopmail.com',
      firstName: 'Cheryl',
      lastName: 'Denler',
      password: '12345678',
      phoneNumber: '2145632583',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2024-02-20T15:57:25.027Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: true,
      clinicalLicenseNumber: '686867',
      clinicalLicenseExpirationDate: '2024-12-13T15:57:25.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '569, South Washington Street, Naperville, Naperville Township, DuPage County, Illinois, United States, 60540, ',
      latitude: '41.7667603197085',
      longitude: '-88.1500602802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 144,
          createdAt: '2024-02-20T15:58:50.534Z',
          updatedAt: '2024-02-20T15:58:50.534Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 9
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 2,
      uniqueId: '72709c1b-75f1-4950-99e2-a36afb1de0bd',
      createdAt: '2024-02-01T18:50:28.273Z',
      updatedAt: '2024-07-30T16:46:01.508Z',
      emailId: 'billy.nursd@yopmail.com',
      firstName: 'Billy',
      lastName: 'Doe',
      password: '12345678',
      phoneNumber: '2145853269',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '1986-02-04T18:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '34236357',
      clinicalLicenseExpirationDate: '2024-02-01T18:48:44.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1671,Mission Hills Road,Northbrook,Northfield Township,Cook County,Illinois,United States,60062',
      latitude: '42.122707',
      longitude: '-87.87002',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 138,
          createdAt: '2024-02-01T18:50:28.727Z',
          updatedAt: '2024-02-01T18:50:28.727Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 2
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 1,
      uniqueId: '10c6d26b-9589-4a7e-a895-2485a2d1fa5d',
      createdAt: '2024-01-18T18:21:20.982Z',
      updatedAt: '2024-09-27T05:26:05.040Z',
      emailId: 'dineshkumar433900@gmail.com',
      firstName: 'Jason',
      lastName: 'Smith',
      password: 'Elite@123',
      phoneNumber: '8526529554',
      gender: 'Male',
      profileImage:
        'https://nursd-development.s3.us-east-2.amazonaws.com/10c6d26b-9589-4a7e-a895-2485a2d1fa5d/916f7323-0861-4409-b8b3-3159038cd08e.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAW2FU4OUCFFXGYJUK%2F20241002%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20241002T132520Z&X-Amz-Expires=86400&X-Amz-Signature=d03c328b311140377c4365915cceeaddbfde6039ab082ae40d8c8b54fa65e51a&X-Amz-SignedHeaders=host&x-id=GetObject',
      mobileId: '',
      dateOfBirth: '1999-08-31T17:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: true,
      clinicalLicenseNumber: '12345678',
      clinicalLicenseExpirationDate: '2024-06-13T17:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: ['Administration'],
      certificationDetails: [],
      educationDetails: [],
      skills: ['Teamwork', 'Time management'],
      EMRorEHRExperience: ['AdvancedMD', 'ABELMed'],
      workExperienceDetails: [
        {
          unit: '',
          state: 'IL',
          title: 'Nurse',
          company: 'NursdHealth',
          country: 'United States',
          endDate: '2024-08-22T21:46:03.080Z',
          startDate: '2024-08-22T21:46:03.080Z',
          positionType: 'Staff',
          currentlyWork: true,
          hourseWorkedWeek: ''
        }
      ],
      uploadDocuments: [],
      fullAddress:
        '2700,Point Lane,Highland Park,West Deerfield Township,Lake County,Illinois,United States,60035,1513',
      latitude: '42.2020009',
      longitude: '-87.83802879999999',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 137,
          createdAt: '2024-01-18T18:21:21.543Z',
          updatedAt: '2024-09-24T21:35:59.931Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 1
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 18,
      uniqueId: '5d99e93d-3d7c-4d33-b04a-62d4e7fde427',
      createdAt: '2024-03-05T19:06:46.538Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'deaven915@yopmail.com',
      firstName: 'Deaven',
      lastName: 'Acox-Bouie',
      password: '12345678',
      phoneNumber: '7089652321',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.133058',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '522,Regent Road,University Park,Monee Township,Will County,Illinois,United States,60484,3000',
      latitude: '41.43816140000001',
      longitude: '-87.6727148',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 204,
          createdAt: '2024-02-20T15:58:50.534Z',
          updatedAt: '2024-02-20T15:58:50.534Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 18
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 19,
      uniqueId: '24181c5e-cf90-4f7f-9e1a-2b0e2dc93fd5',
      createdAt: '2024-03-05T19:06:46.462Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'btillman1222@yopmail.com',
      firstName: 'Brenda',
      lastName: 'Tillman',
      password: '12345678',
      phoneNumber: '7793643789',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.119341',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1017,Lois Place,Lois Place,Joliet,Joliet Township,Will County,Illinois,United States,60435',
      latitude: '41.5405981',
      longitude: '-88.1274162',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 205,
          createdAt: '2024-02-21T18:13:59.271Z',
          updatedAt: '2024-02-21T18:13:59.271Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 19
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 21,
      uniqueId: '6ce0528d-29d0-44f5-a9d7-ec2fcfb00c95',
      createdAt: '2024-03-05T19:06:46.660Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'mscara80@yopmail.com',
      firstName: 'Cara',
      lastName: 'Hollis',
      password: '12345678',
      phoneNumber: '7735955189',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.107746',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1329,Ridge Road,Homewood,Thornton Township,Cook County,Illinois,United States,60430,1918',
      latitude: '41.5612138',
      longitude: '-87.6495193',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 207,
          createdAt: '2024-02-29T16:24:55.867Z',
          updatedAt: '2024-02-29T16:24:55.867Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 21
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 36,
      uniqueId: 'ecf1979a-a81a-44b6-97ff-2b7f0056c726',
      createdAt: '2024-03-07T21:33:28.702Z',
      updatedAt: '2024-07-30T16:46:09.650Z',
      emailId: 'devnurse2@yopmail.com',
      firstName: 'Dev',
      lastName: 'Nurse2',
      password: '12345678',
      phoneNumber: '5451453689',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-03-07T06:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: true,
      clinicalLicenseNumber: '43.4569878',
      clinicalLicenseExpirationDate: '2027-05-13T20:32:05.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7257, West Touhy Avenue, Chicago, , Cook County, Illinois, United States, 60631, 4342',
      latitude: '42.0101165697085',
      longitude: '-87.81038578029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 152,
          createdAt: '2024-03-05T18:40:31.411Z',
          updatedAt: '2024-03-05T18:40:31.411Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 36
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 35,
      uniqueId: 'db182811-3217-4944-8d0a-4ad31a9f8289',
      createdAt: '2024-03-07T21:28:11.030Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'devnurse1@yopmail.com',
      firstName: 'Dev',
      lastName: 'Nurse',
      password: '12345678',
      phoneNumber: '4589652569',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-03-07T06:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: true,
      clinicalLicenseNumber: '43.4569874',
      clinicalLicenseExpirationDate: '2025-03-21T20:25:02.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1845, Raymond Drive, Northbrook, Northfield Township, Cook County, Illinois, United States, 60062, 6712',
      latitude: '42.1100658697085',
      longitude: '-87.82744988029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 151,
          createdAt: '2024-03-05T18:40:31.387Z',
          updatedAt: '2024-03-05T18:40:31.387Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 35
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 29,
      uniqueId: '493fdea5-1d8e-4ea0-9d9f-6ffd08f4f540',
      createdAt: '2024-03-05T19:06:47.290Z',
      updatedAt: '2024-04-21T23:45:13.729Z',
      emailId: 'd.pryor10@yopmail.com',
      firstName: 'Dorothy',
      lastName: 'Pryor',
      password: '12345678',
      phoneNumber: '7082243791',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.10297',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '132,Lake Hill Drive,Steger,Crete Township,Will County,Illinois,United States,60475,1584',
      latitude: '41.4620074',
      longitude: '-87.62621560000001',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 215,
          createdAt: '2024-03-05T19:06:46.954Z',
          updatedAt: '2024-03-05T19:06:46.954Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 29
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 31,
      uniqueId: '5782af29-ace5-497b-8442-4da549930c80',
      createdAt: '2024-03-05T19:24:28.554Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'fosterjosephine69@yopmail.com',
      firstName: 'Josephine',
      lastName: 'Diaz',
      password: '12345678',
      phoneNumber: '7085516593',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: 'N/A',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '21342,Main Street,Matteson,Rich Township,Cook County,Illinois,United States,60443,2564',
      latitude: '41.5010644',
      longitude: '-87.7036173',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 214,
          createdAt: '2024-03-05T19:06:46.950Z',
          updatedAt: '2024-03-05T19:06:46.950Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 31
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 34,
      uniqueId: 'd2d993d0-8303-4534-9f85-6a486b7ab445',
      createdAt: '2024-03-05T19:27:47.446Z',
      updatedAt: '2024-04-16T20:09:19.643Z',
      emailId: 'ladouceurjanet@yopmail.com',
      firstName: 'Janet',
      lastName: 'Ladouceur',
      password: '12345678',
      phoneNumber: '6302479361',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '41.231641',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '404,North Pinecrest Road,Bolingbrook,Du Page Township,Will County,Illinois,United States,60440,2138',
      latitude: '41.7112436',
      longitude: '-88.05117',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 150,
          createdAt: '2024-03-01T14:53:47.826Z',
          updatedAt: '2024-03-01T14:53:47.826Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 34
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 51,
      uniqueId: 'fecdbf45-b473-483d-aa4f-7cf81785ec74',
      createdAt: '2024-04-16T19:42:51.544Z',
      updatedAt: '2024-06-20T13:12:24.991Z',
      emailId: 'soshidele@yopmail.com',
      firstName: 'Saheed ',
      lastName: 'Oshidele',
      password: '12345678',
      phoneNumber: '7732731728',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-507944',
      clinicalLicenseExpirationDate: '2030-07-11T19:41:40.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7200, North Rogers Avenue, Chicago, , Cook County, Illinois, United States, 60645, 2414',
      latitude: '42.01114121970851',
      longitude: '-87.6841981302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 167,
          createdAt: '2024-03-05T19:24:28.745Z',
          updatedAt: '2024-03-05T19:24:28.745Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 51
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 45,
      uniqueId: '1de14a01-7c15-4316-a147-e2e9e558fd98',
      createdAt: '2024-04-16T19:31:55.724Z',
      updatedAt: '2024-04-17T12:54:45.090Z',
      emailId: 'istephaniegee@yopmail.com',
      firstName: 'Estefania ',
      lastName: 'Gonzalez',
      password: '12345678',
      phoneNumber: '2243130617',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043-130397',
      clinicalLicenseExpirationDate: '2027-04-22T18:41:37.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '8925, Robin Drive, Des Plaines, Maine Township, Cook County, Illinois, United States, 60016, 5491',
      latitude: '42.0409882697085',
      longitude: '-87.8545394802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 161,
          createdAt: '2024-03-05T19:06:47.213Z',
          updatedAt: '2024-03-05T19:06:47.213Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 45
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 46,
      uniqueId: '1e80ad4b-4591-4b45-b3ed-6a7d05d00ce9',
      createdAt: '2024-04-16T19:33:11.612Z',
      updatedAt: '2024-04-17T12:56:37.286Z',
      emailId: 'gennyhrstova@yopmail.com',
      firstName: 'Genoveva ',
      lastName: 'Hristova',
      password: '12345678',
      phoneNumber: '8473610192',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043-109536',
      clinicalLicenseExpirationDate: '2027-09-02T19:31:57.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1048, West Catalpa Avenue, Chicago, , Cook County, Illinois, United States, 60640, 1509',
      latitude: '41.9806274197085',
      longitude: '-87.6583048302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 162,
          createdAt: '2024-03-05T19:06:47.238Z',
          updatedAt: '2024-03-05T19:06:47.238Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 46
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 47,
      uniqueId: '972c2af4-67b4-4cd2-b679-28fcabf4ed8d',
      createdAt: '2024-04-16T19:34:32.268Z',
      updatedAt: '2024-04-17T12:57:14.221Z',
      emailId: 'joemugisha@yopmail.com',
      firstName: 'Joseph ',
      lastName: 'Mugisha',
      password: '12345678',
      phoneNumber: '8475292614',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043-111621',
      clinicalLicenseExpirationDate: '2028-08-20T19:33:13.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7527, Bristol Lane, Hanover Park, Schaumburg Township, Cook County, Illinois, United States, 60133, 2591',
      latitude: '42.0077349197085',
      longitude: '-88.1441002802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 163,
          createdAt: '2024-03-05T19:06:47.242Z',
          updatedAt: '2024-03-05T19:06:47.242Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 47
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 48,
      uniqueId: '6df97643-9e04-4fed-8475-117606b14872',
      createdAt: '2024-04-16T19:35:40.818Z',
      updatedAt: '2024-04-17T12:57:41.955Z',
      emailId: 'lauraarena595@yopmail.com',
      firstName: 'Laura ',
      lastName: 'Arena',
      password: '12345678',
      phoneNumber: '6306961533',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-416319',
      clinicalLicenseExpirationDate: '2026-10-07T19:34:33.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7224, Trey Road, McHenry, McHenry Township, McHenry County, Illinois, United States, 60050, 7472',
      latitude: '42.3315562197085',
      longitude: '-88.33988843029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 164,
          createdAt: '2024-03-05T19:06:47.286Z',
          updatedAt: '2024-03-05T19:06:47.286Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 48
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 58,
      uniqueId: '94c28a78-8791-47dc-ac53-e7f2c7ecd74e',
      createdAt: '2024-05-20T11:31:22.030Z',
      updatedAt: '2024-06-18T20:52:08.045Z',
      emailId: 'carolmurfy@yopmail.com',
      firstName: 'CAROL',
      lastName: 'MCKINNEY',
      password: '12345678',
      phoneNumber: '7082993759',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-05-19T18:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:28:59.381Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '13959, Deer Ridge Road, Bloomington, Dale Township, McLean County, Illinois, United States, 61705, 7801',
      latitude: '40.48563316970851',
      longitude: '-89.0896401302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 222,
          createdAt: '2024-03-05T19:06:47.238Z',
          updatedAt: '2024-03-05T19:06:47.238Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 58
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 55,
      uniqueId: '10e78c28-69d1-4ecc-8f52-f8ac7fcd3998',
      createdAt: '2024-04-20T01:11:40.949Z',
      updatedAt: '2024-04-20T01:11:40.949Z',
      emailId: 'imcindycole123@yopmail.com',
      firstName: 'Cindy ',
      lastName: 'Moore',
      password: '12345678',
      phoneNumber: '6306158453',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-19T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.395744',
      clinicalLicenseExpirationDate: '2026-11-28T02:09:16.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '926, Garfield Avenue, Aurora, Aurora Township, Kane County, Illinois, United States, 60506, 4953',
      latitude: '41.7583424197085',
      longitude: '-88.34043983029149',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 171,
          createdAt: '2024-03-07T21:28:11.341Z',
          updatedAt: '2024-03-07T21:28:11.341Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 55
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 57,
      uniqueId: '8088a84f-3cc8-4244-b113-8dffa7639a38',
      createdAt: '2024-05-20T11:28:58.705Z',
      updatedAt: '2024-05-20T11:28:58.705Z',
      emailId: 'annembarragan@yopmail.com',
      firstName: 'ANNE',
      lastName: 'BARRAGAN',
      password: '12345678',
      phoneNumber: '7086683837',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-05-19T18:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:12:29.570Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7709, 161st Street, Tinley Park, Orland Township, Cook County, Illinois, United States, 60477, 1582',
      latitude: '41.5967783697085',
      longitude: '-87.80776713029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 173,
          createdAt: '2024-03-13T15:34:55.340Z',
          updatedAt: '2024-03-13T15:34:55.340Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 57
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 60,
      uniqueId: '90c12dde-69d8-43fc-92f6-33a09d720e75',
      createdAt: '2024-05-20T11:39:17.118Z',
      updatedAt: '2024-05-20T11:39:17.118Z',
      emailId: 'clarkmom.wc@yopmail.com',
      firstName: 'WENDY',
      lastName: 'CLARK',
      password: '12345678',
      phoneNumber: '8153829709',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-05-19T18:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:35:25.745Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '24860, Vermette Road, Plainfield, Wheatland Township, Will County, Illinois, United States, 60585, 7738',
      latitude: '41.6410375697085',
      longitude: '-88.22680683029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 223,
          createdAt: '2024-03-05T19:06:47.242Z',
          updatedAt: '2024-03-05T19:06:47.242Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 60
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 64,
      uniqueId: '90d11ad3-1a38-49d4-bab6-ecbb577877eb',
      createdAt: '2024-05-20T11:52:26.573Z',
      updatedAt: '2024-05-20T12:37:25.521Z',
      emailId: 't.janca@yopmail.com',
      firstName: 'Thomas',
      lastName: 'Janca',
      password: '12345678',
      phoneNumber: '8154195041',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-05-19T18:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:50:17.649Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1538, Illinois 102, Bourbonnais, Bourbonnais Township, Kankakee County, Illinois, United States, 60914, 4352',
      latitude: '41.16591431970851',
      longitude: '-87.90694558029149',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 175,
          createdAt: '2024-04-11T14:26:14.324Z',
          updatedAt: '2024-04-11T14:26:14.324Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 64
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 65,
      uniqueId: 'bbee30c2-be71-429f-a292-ad74e385473b',
      createdAt: '2024-06-05T03:24:57.132Z',
      updatedAt: '2024-06-05T03:24:57.132Z',
      emailId: 'milgrac@yopmail.com',
      firstName: 'Grazyna',
      lastName: 'Milon',
      password: '12345678',
      phoneNumber: '7084093587',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.457141',
      clinicalLicenseExpirationDate: '2026-06-04T03:22:04.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2431, Enterprise Drive, Westchester, Proviso Township, Cook County, Illinois, United States, 60154, 5825',
      latitude: '41.84204701970851',
      longitude: '-87.90966813029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 176,
          createdAt: '2024-04-16T18:31:39.998Z',
          updatedAt: '2024-04-16T18:31:39.998Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 65
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 68,
      uniqueId: 'a4e47569-13de-474b-842f-466ded64b88b',
      createdAt: '2024-06-05T03:31:54.209Z',
      updatedAt: '2024-06-05T03:31:54.209Z',
      emailId: 'neko1172@yopmail.com',
      firstName: 'Daniel',
      lastName: 'Barajas',
      password: '12345678',
      phoneNumber: '6307652780',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.128274',
      clinicalLicenseExpirationDate: '2024-06-05T03:30:19.176Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '38, North Calhoun Street, Aurora, Aurora Township, Kane County, Illinois, United States, 60505, 4506',
      latitude: '41.7510688197085',
      longitude: '-88.28416238029149',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 179,
          createdAt: '2024-04-16T18:39:28.157Z',
          updatedAt: '2024-04-16T18:39:28.157Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 68
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 69,
      uniqueId: '85b3510f-e750-4a9c-bd73-956bf059ae09',
      createdAt: '2024-06-05T03:34:21.535Z',
      updatedAt: '2024-06-05T03:34:21.535Z',
      emailId: 'dkummen@yopmail.com',
      firstName: 'Deborah ',
      lastName: 'Kummen',
      password: '12345678',
      phoneNumber: '2246887432',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.268936',
      clinicalLicenseExpirationDate: '2024-06-05T03:31:55.617Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '13544, Stone Hill Drive, Huntley, Rutland Township, Kane County, Illinois, United States, 60142, 7824',
      latitude: '42.1404747697085',
      longitude: '-88.4620178802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 180,
          createdAt: '2024-04-16T18:41:35.435Z',
          updatedAt: '2024-04-19T10:53:05.512Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 69
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 70,
      uniqueId: 'c41c382e-a4ce-4bc2-be86-d7d97d804f25',
      createdAt: '2024-06-05T03:35:43.112Z',
      updatedAt: '2024-06-05T03:35:43.112Z',
      emailId: 'manolet90706@yopmail.com',
      firstName: 'Emmanuel ',
      lastName: 'Montinola',
      password: '12345678',
      phoneNumber: '8159194990',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.108970',
      clinicalLicenseExpirationDate: '2024-06-05T03:34:22.911Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '13900, Cambridge Circle, Plainfield, Plainfield Township, Will County, Illinois, United States, 60544, 7376',
      latitude: '41.6288867197085',
      longitude: '-88.1698560802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 181,
          createdAt: '2024-04-16T19:31:56.054Z',
          updatedAt: '2024-04-16T19:31:56.054Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 70
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 71,
      uniqueId: '88cc4db9-3735-4822-b034-4f24ee2703f7',
      createdAt: '2024-06-05T03:37:30.119Z',
      updatedAt: '2024-06-13T16:38:34.091Z',
      emailId: 'gautt.ecm@yopmail.com',
      firstName: 'Gary',
      lastName: 'Utt',
      password: '12345678',
      phoneNumber: '7086485879',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.115695',
      clinicalLicenseExpirationDate: '2024-06-05T03:35:44.817Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '8513, Brookside Glen Drive, Tinley Park, Frankfort Township, Will County, Illinois, United States, 60487, 7044',
      latitude: '41.5307019197085',
      longitude: '-87.8254878802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 182,
          createdAt: '2024-04-16T19:33:11.653Z',
          updatedAt: '2024-04-16T19:33:11.653Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 71
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 72,
      uniqueId: '6e79ccc5-6d1e-4406-9991-d2668d3617a2',
      createdAt: '2024-06-05T03:38:51.530Z',
      updatedAt: '2024-06-05T03:38:51.530Z',
      emailId: 'giedre@yopmail.com',
      firstName: 'Giedre',
      lastName: 'Lopez',
      password: '12345678',
      phoneNumber: '6302672291',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.416942',
      clinicalLicenseExpirationDate: '2024-06-05T03:37:33.216Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '726, South Naperville Road, Wheaton, Milton Township, DuPage County, Illinois, United States, 60189, 6408',
      latitude: '41.8564105697085',
      longitude: '-88.1039593302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 227,
          createdAt: '2024-03-05T19:24:28.745Z',
          updatedAt: '2024-03-05T19:24:28.745Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 72
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 6,
      uniqueId: '0fc0fd7e-69d4-47df-91ff-44a61d03e123',
      createdAt: '2024-02-14T12:17:34.217Z',
      updatedAt: '2024-07-22T18:51:58.836Z',
      emailId: 'kathyn@yopmail.com',
      firstName: 'Kathleen',
      lastName: 'Needham',
      password: '12345678',
      phoneNumber: '6302479745',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T06:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.119398',
      clinicalLicenseExpirationDate: '2027-01-22T18:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '10943,Ursula Drive,Willowbrook,Lyons Township,Cook County,Illinois,United States,60527,1126',
      latitude: '41.733034',
      longitude: '-87.8891142',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 146,
          createdAt: '2024-02-21T18:13:59.271Z',
          updatedAt: '2024-03-04T19:46:36.355Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: false,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 6
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 5,
      uniqueId: '0fc0fd7e-69d4-47df-91ff-44a61d03e970',
      createdAt: '2024-02-08T20:54:55.994Z',
      updatedAt: '2024-09-13T16:39:32.584Z',
      emailId: 'ralphym@yopmail.com',
      firstName: 'Ralphy',
      lastName: 'Morrow ',
      password: '12345678',
      phoneNumber: '5231459635',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Tue Feb 04 1986 12:00:00 GMT-0600',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '5777888',
      clinicalLicenseExpirationDate: 'Fri Jan 22 2027 12:00:00 GMT-0600',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7635,Knox Avenue,Skokie,Niles Township,Cook County,Illinois,United States,60076,3741',
      latitude: '42.02003029999999',
      longitude: '-87.7437496',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 141,
          createdAt: '2024-02-08T20:54:56.473Z',
          updatedAt: '2024-02-08T20:54:56.473Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 5
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 77,
      uniqueId: 'c5bd5a08-282e-4843-b800-c350314d307b',
      createdAt: '2024-06-05T03:49:04.694Z',
      updatedAt: '2024-06-17T10:21:08.712Z',
      emailId: 'hairbymc4@yopmail.com',
      firstName: 'Monica',
      lastName: 'Cardenas',
      password: '12345678',
      phoneNumber: '6302544877',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.129385',
      clinicalLicenseExpirationDate: '2024-06-05T03:46:14.541Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '8005, Brockton Court South, Hanover Park, Schaumburg Township, Cook County, Illinois, United States, 60133, 2319',
      latitude: '42.0130649197085',
      longitude: '-88.13954633029152',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 228,
          createdAt: '2024-03-05T19:25:47.388Z',
          updatedAt: '2024-03-05T19:25:47.388Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 77
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 78,
      uniqueId: '246b2140-c91a-473f-bd8a-7f1cdf7afeab',
      createdAt: '2024-06-05T03:51:41.674Z',
      updatedAt: '2024-06-05T03:51:41.674Z',
      emailId: 'qutester@yopmail.com',
      firstName: 'Qutester ',
      lastName: 'Mapp',
      password: '12345678',
      phoneNumber: '7733441780',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.081480',
      clinicalLicenseExpirationDate: '2024-06-05T03:49:12.926Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '10629, South Lowe Avenue, Chicago, , Cook County, Illinois, United States, 60628, 2311',
      latitude: '41.69927531970851',
      longitude: '-87.6401972302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 229,
          createdAt: '2024-05-20T11:28:58.749Z',
          updatedAt: '2024-05-20T11:28:58.749Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 78
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 79,
      uniqueId: 'f87fe714-cccf-465e-8686-f4bd77899b5d',
      createdAt: '2024-06-05T03:53:17.877Z',
      updatedAt: '2024-06-05T03:53:17.877Z',
      emailId: 'deahrebecca4@yopmail.com',
      firstName: 'Rebecca',
      lastName: 'Deah',
      password: '12345678',
      phoneNumber: '7733395968',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.267302',
      clinicalLicenseExpirationDate: '2024-06-05T03:51:42.651Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '9546, South Paxton Avenue, Chicago, , Cook County, Illinois, United States, 60617, 4836',
      latitude: '41.7198006197085',
      longitude: '-87.5719863802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 187,
          createdAt: '2024-04-16T19:42:51.592Z',
          updatedAt: '2024-06-05T16:02:06.035Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '31',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 79
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 20,
      uniqueId: '784fd2ea-a1eb-41e0-ba29-87485f7fd575',
      createdAt: '2024-03-05T19:06:46.660Z',
      updatedAt: '2024-03-28T17:56:16.706Z',
      emailId: 'vanessa_l98@yopmail.com',
      firstName: 'Vanessa',
      lastName: 'Lamarre',
      password: '12345678',
      phoneNumber: '7082755579',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Thu Jul 06 1989 12:00:00 GMT-0500',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '41.544184',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '939,Maple Road,Flossmoor,Rich Township,Cook County,Illinois,United States,60422,1061',
      latitude: '41.5449925',
      longitude: '-87.707132',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 206,
          createdAt: '2024-02-21T18:13:59.271Z',
          updatedAt: '2024-03-04T19:46:36.355Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: false,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 20
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 28,
      uniqueId: 'b68d8bfd-89c7-418e-b04a-ad72cf0c5496',
      createdAt: '2024-03-05T19:06:47.184Z',
      updatedAt: '2024-04-05T10:40:35.786Z',
      emailId: 'ischysia36@yopmail.com',
      firstName: 'Ischysia',
      lastName: 'Coleman',
      password: '12345678',
      phoneNumber: '7086918733',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.127083',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        'UNIT 5,5150,Shadow Creek Drive,Oak Forest,Bremen Township,Cook County,Illinois,United States,60452,3884',
      latitude: '41.60012690000001',
      longitude: '-87.7446665',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 147,
          createdAt: '2024-02-29T16:24:55.867Z',
          updatedAt: '2024-02-29T16:24:55.867Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 28
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 30,
      uniqueId: '62b16adf-55ce-42d8-9dd8-1cba48989cea',
      createdAt: '2024-03-05T19:23:26.372Z',
      updatedAt: '2024-04-21T20:14:47.568Z',
      emailId: 'deedo2001@yopmail.com',
      firstName: 'Dee',
      lastName: 'Okewole',
      password: '12345678',
      phoneNumber: '7134596618',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: 'N/A',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7505,162nd Street,Tinley Park,Orland Township,Cook County,Illinois,United States,60477,1540',
      latitude: '41.5963775',
      longitude: '-87.8016761',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 216,
          createdAt: '2024-03-05T19:06:46.971Z',
          updatedAt: '2024-03-05T19:06:46.971Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 30
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 32,
      uniqueId: 'e1414067-1d48-44b7-83ae-4b07d43e63e3',
      createdAt: '2024-03-05T19:25:47.318Z',
      updatedAt: '2024-04-03T16:27:24.804Z',
      emailId: 'knndcarrington@yopmail.com',
      firstName: 'Kennedy',
      lastName: 'Carrington',
      password: '12345678',
      phoneNumber: '7082659181',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: 'N/A',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '3518,Arthur Road,Crete,Crete Township,Will County,Illinois,United States,60417,1308',
      latitude: '41.4659834',
      longitude: '-87.5937364',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 217,
          createdAt: '2024-03-05T19:06:46.994Z',
          updatedAt: '2024-03-05T19:06:46.994Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 32
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 33,
      uniqueId: 'e9ba10be-7917-45a0-9b9f-90a3a6e68e9f',
      createdAt: '2024-03-05T19:26:17.052Z',
      updatedAt: '2024-05-24T13:16:26.795Z',
      emailId: 'tashasmith1012@yopmail.com',
      firstName: 'Tasha',
      lastName: 'Smith-Michael ',
      password: '12345678',
      phoneNumber: '3123162329',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Tue Oct 17 1972 12:00:00 GMT-0500',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: 'N/A',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '15112,Cyrus Drive,Manhattan,Manhattan Township,Will County,Illinois,United States,60442',
      latitude: '41.4387705',
      longitude: '-87.9794082',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 149,
          createdAt: '2024-02-29T21:20:17.333Z',
          updatedAt: '2024-03-01T14:48:14.570Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: false,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 33
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 17,
      uniqueId: '3c96e2dd-687c-48cd-85d5-581bf86e8206',
      createdAt: '2024-03-05T19:06:46.601Z',
      updatedAt: '2024-05-31T19:55:12.928Z',
      emailId: 'cld1728@yopmail.com',
      firstName: 'Cheryl',
      lastName: 'Denler',
      password: '12345678',
      phoneNumber: '7085805506',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '41.227819',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1728, Mary Ann Lane, Lockport, Lockport Township, Will County, Illinois, United States, 60441, ',
      latitude: '41.5772920197085',
      longitude: '-88.05266808029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 203,
          createdAt: '2024-02-20T15:51:13.148Z',
          updatedAt: '2024-02-20T15:51:13.148Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 17
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 50,
      uniqueId: '451ee1b9-a0b0-4cb1-bcc1-2f539a379559',
      createdAt: '2024-04-16T19:38:58.049Z',
      updatedAt: '2024-06-18T13:35:10.607Z',
      emailId: 'jlstella94@yopmail.com',
      firstName: 'Jaime ',
      lastName: 'Logan',
      password: '12345678',
      phoneNumber: '8153553794',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043-123855',
      clinicalLicenseExpirationDate: '2029-01-02T20:37:47.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '738, Candleridge Court, Bartlett, Hanover Township, Cook County, Illinois, United States, 60103, 4317',
      latitude: '41.98708191970849',
      longitude: '-88.1693711802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 166,
          createdAt: '2024-03-05T19:23:26.489Z',
          updatedAt: '2024-03-05T19:23:26.489Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 50
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 86,
      uniqueId: '41eeec85-6916-43b6-a309-9048daa8751c',
      createdAt: '2024-06-21T14:37:20.116Z',
      updatedAt: '2024-06-21T14:37:20.116Z',
      emailId: 'swoods7450@yopmail.com',
      firstName: 'Sarah',
      lastName: 'Woods',
      password: '12345678',
      phoneNumber: '2249447162',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-02T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.132891',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '685,Chester Avenue,Elgin,Elgin Township,Kane County,Illinois,United States,60120,3092',
      latitude: '42.0520647',
      longitude: '-88.26391369999999',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 219,
          createdAt: '2024-03-05T19:06:47.184Z',
          updatedAt: '2024-03-05T19:06:47.184Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 86
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 52,
      uniqueId: '9f3c1777-0154-434d-89e6-d016ebdc3b16',
      createdAt: '2024-04-16T19:43:49.699Z',
      updatedAt: '2024-04-17T22:55:52.444Z',
      emailId: 'sherry_hardesty7@yopmail.com',
      firstName: 'Sherilyn ',
      lastName: 'Hardesty',
      password: '12345678',
      phoneNumber: '2172958582',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043-121720',
      clinicalLicenseExpirationDate: '2028-07-18T19:42:52.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1650, Kingsdale Road, Hoffman Estates, Schaumburg Township, Cook County, Illinois, United States, 60169, 4039',
      latitude: '42.0550394697085',
      longitude: '-88.11507938029152',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 168,
          createdAt: '2024-03-05T19:25:47.388Z',
          updatedAt: '2024-03-05T19:25:47.388Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 52
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 53,
      uniqueId: '164caf5b-53cd-441a-ab9c-7cdec22b9e05',
      createdAt: '2024-04-20T01:07:10.611Z',
      updatedAt: '2024-05-24T18:51:39.752Z',
      emailId: 'calimenti@yopmail.com',
      firstName: 'Christine ',
      lastName: 'Alimenti',
      password: '12345678',
      phoneNumber: '6306218408',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-19T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.059862',
      clinicalLicenseExpirationDate: '2027-08-07T01:05:27.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '3N304, Valewood Road, West Chicago, Wayne Township, DuPage County, Illinois, United States, 60185, 1346',
      latitude: '41.9189042697085',
      longitude: '-88.2045246302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 169,
          createdAt: '2024-03-05T19:26:17.129Z',
          updatedAt: '2024-04-18T21:08:10.273Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '45',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 53
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 59,
      uniqueId: '2d9cf977-8d13-4b7f-aa53-d6a4fa344e8e',
      createdAt: '2024-05-20T11:34:57.743Z',
      updatedAt: '2024-05-31T12:58:06.009Z',
      emailId: 'mcdonough399@yopmail.com',
      firstName: 'ELIZABETH',
      lastName: 'MC DONOUGH',
      password: '12345678',
      phoneNumber: '7088901282',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Sun Dec 27 1981 12:00:00 GMT-0600',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:31:22.213Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '6734, Edgewood Road, Palos Heights, Worth Township, Cook County, Illinois, United States, 60463, 2261',
      latitude: '41.65699891970849',
      longitude: '-87.78743688029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 174,
          createdAt: '2024-03-28T20:46:46.328Z',
          updatedAt: '2024-03-28T20:46:46.328Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 59
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 61,
      uniqueId: 'edbf710a-6901-4cf8-9110-e5f25273f04b',
      createdAt: '2024-05-20T11:41:18.960Z',
      updatedAt: '2024-05-30T21:24:48.213Z',
      emailId: 'talleytara5@yopmail.com',
      firstName: 'Tara',
      lastName: 'Tally',
      password: '12345678',
      phoneNumber: '2192131019',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Mon Jul 19 1999 12:00:00 GMT-0500',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:39:16.918Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '10437, Privet Drive, Crown Point, Center Township, Lake County, Indiana, United States, 46307, 5383',
      latitude: '41.42784801970849',
      longitude: '-87.4304250302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 224,
          createdAt: '2024-03-05T19:06:47.286Z',
          updatedAt: '2024-03-05T19:06:47.286Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 61
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 62,
      uniqueId: '9a2d8b11-a5d4-4dfa-97db-63eef91f82d2',
      createdAt: '2024-05-20T11:48:03.482Z',
      updatedAt: '2024-06-26T16:15:02.842Z',
      emailId: 'jadhaas1@yopmail.com',
      firstName: 'Jody',
      lastName: 'Haas',
      password: '12345678',
      phoneNumber: '6307306882',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-05-19T18:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.112663',
      clinicalLicenseExpirationDate: 'Fri Jan 31 2025 12:00:00 GMT-0600',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: ['Home Health'],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '291, Aspen Lane, Aurora, Naperville Township, DuPage County, Illinois, United States, 60504, 5149',
      latitude: '41.74844056970849',
      longitude: '-88.2474890802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 225,
          createdAt: '2024-03-05T19:06:47.388Z',
          updatedAt: '2024-03-05T19:06:47.388Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 62
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 63,
      uniqueId: '3df1724a-c7a6-4037-a505-111fa7044eaa',
      createdAt: '2024-05-20T11:50:18.098Z',
      updatedAt: '2024-05-31T22:06:32.747Z',
      emailId: 'sstruble81@yopmail.com',
      firstName: 'Sharon',
      lastName: 'Struble',
      password: '12345678',
      phoneNumber: '8157158955',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-05-19T18:30:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '',
      clinicalLicenseExpirationDate: '2024-05-20T11:48:28.834Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2216, Irvine Lane, Plainfield, Plainfield Township, Will County, Illinois, United States, 60586, 8374',
      latitude: '41.56109576970849',
      longitude: '-88.2058415802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 226,
          createdAt: '2024-03-05T19:23:26.489Z',
          updatedAt: '2024-03-05T19:23:26.489Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 63
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 42,
      uniqueId: '234dac62-7a94-48cf-8963-a4a3398dc394',
      createdAt: '2024-04-16T18:36:48.477Z',
      updatedAt: '2024-04-18T10:51:08.222Z',
      emailId: 'hkeys331@yopmail.com',
      firstName: 'Hannah ',
      lastName: 'Sanders-Mud',
      password: '12345678',
      phoneNumber: '8475710493',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Thu Mar 31 1994 12:00:00 GMT-0600',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-530327',
      clinicalLicenseExpirationDate: '2027-08-13T18:35:19.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [
        'Emergency',
        'Critical Care',
        'Neurology',
        'Trauma',
        'Home Health'
      ],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2530, Watermark Terrace, Elgin, Dundee Township, Kane County, Illinois, United States, 60124, ',
      latitude: '42.0949520197085',
      longitude: '-88.3388434802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 158,
          createdAt: '2024-03-05T19:06:47.024Z',
          updatedAt: '2024-03-05T19:06:47.024Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 42
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 25,
      uniqueId: 'ebc161f7-825f-4e48-bf5c-06de4274ee1a',
      createdAt: '2024-03-05T19:06:47.138Z',
      updatedAt: '2024-09-27T05:27:53.732Z',
      emailId: 'eignasenoj@yopmail.com',
      firstName: 'Angelique',
      lastName: 'Jones',
      password: '12345678',
      phoneNumber: '7087939346',
      gender: 'Female',
      profileImage: '',
      mobileId: 'ExponentPushToken[y1IQLYPftK8GugQcEMCnhj]',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: 'N/A',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '4526,Provincetown Drive,Country Club Hills,Rich Township,Cook County,Illinois,United States,60478,5504',
      latitude: '41.5522859',
      longitude: '-87.7163023',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 211,
          createdAt: '2024-03-05T18:40:31.387Z',
          updatedAt: '2024-03-05T18:40:31.387Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 25
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 22,
      uniqueId: '374376a7-f528-4775-a171-304cb57fc96c',
      createdAt: '2024-03-05T19:06:46.660Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'dorshrd@yopmail.com',
      firstName: 'Doris',
      lastName: 'Sheridan',
      password: '12345678',
      phoneNumber: '7733749937',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.071934',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '9548,South Paxton Avenue,Jeffrey Manor,Chicago,Cook County,Illinois,United States,60617,4836',
      latitude: '41.7210491',
      longitude: '-87.5707779',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 208,
          createdAt: '2024-02-29T16:29:04.026Z',
          updatedAt: '2024-04-12T16:03:01.833Z',
          days: ['Mon', 'Tue', 'Thu', 'Fri', 'Sun', 'Sat', 'Wed'],
          duration: [],
          timing: ['Morning', 'Evening', 'Afternoon', 'Night'],
          minDistance: '1',
          maxDistance: '33',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: false,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 22
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 23,
      uniqueId: '0c45d4c7-35cb-4bff-ae1f-dc9ade5acf8a',
      createdAt: '2024-03-05T19:06:47.096Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'theprosperouswoman@yopmail.com',
      firstName: 'Trestine',
      lastName: 'Duncan',
      password: '12345678',
      phoneNumber: '7082892400',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.103818',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '4429,Arbutus Lane,East Chicago,North Township,Lake County,Indiana,United States,46312,3113',
      latitude: '41.6321597',
      longitude: '-87.4409077',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 209,
          createdAt: '2024-02-29T21:20:17.333Z',
          updatedAt: '2024-03-01T14:48:14.570Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: false,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 23
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 24,
      uniqueId: '407cab56-69a3-4104-8abd-c80179a0bce9',
      createdAt: '2024-03-05T19:06:47.116Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'nidiawisdom77@yopmail.com',
      firstName: 'Nidia',
      lastName: 'Carrilo',
      password: '12345678',
      phoneNumber: '8722304884',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.122174',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2952,Ridge Road,Lansing,Thornton Township,Cook County,Illinois,United States,60438,3040',
      latitude: '41.5649216',
      longitude: '-87.54466939999999',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 210,
          createdAt: '2024-03-01T14:53:47.826Z',
          updatedAt: '2024-03-01T14:53:47.826Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 24
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 26,
      uniqueId: '7b25af25-0ec1-405a-9d53-43f7af03a331',
      createdAt: '2024-03-05T19:06:47.144Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'ope.apata03@yopmail.com',
      firstName: 'Yemi',
      lastName: 'Apata',
      password: '12345678',
      phoneNumber: '7089790105',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '41.515198',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '29,Dogwood Street,Park Forest,Bloom Township,Cook County,Illinois,United States,60466,1811',
      latitude: '41.4869598',
      longitude: '-87.6728447',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 212,
          createdAt: '2024-03-05T18:40:31.411Z',
          updatedAt: '2024-03-05T18:40:31.411Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 26
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 27,
      uniqueId: 'cb77dfeb-33bc-4f64-8761-2f5b35b5bb38',
      createdAt: '2024-03-05T19:06:47.163Z',
      updatedAt: '2024-03-13T13:41:24.047Z',
      emailId: 'valerielathan@yopmail.com',
      firstName: 'Valerie',
      lastName: 'Lathan',
      password: '12345678',
      phoneNumber: '3128002852',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-01T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.120613',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '609,Cody Lane,University Park,Monee Township,Will County,Illinois,United States,60484,3233',
      latitude: '41.4461407',
      longitude: '-87.67692770000001',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 213,
          createdAt: '2024-03-05T19:06:46.913Z',
          updatedAt: '2024-03-05T19:06:46.913Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 27
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 38,
      uniqueId: '1c9bee1c-3277-48e6-8517-506dce2a7773',
      createdAt: '2024-03-28T20:46:46.265Z',
      updatedAt: '2024-03-30T00:46:41.482Z',
      emailId: 'kiana1m@yopmail.com',
      firstName: 'Kiana',
      lastName: 'McGuire',
      password: '12345678',
      phoneNumber: '7089792842',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '1994-07-01T17:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '41.1313131',
      clinicalLicenseExpirationDate: '2026-05-01T20:36:17.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1737, 225th Street, Sauk Village, Bloom Township, Cook County, Illinois, United States, 60411, 8969',
      latitude: '41.47914076970849',
      longitude: '-87.57534033029148',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 154,
          createdAt: '2024-03-05T19:06:46.950Z',
          updatedAt: '2024-03-05T19:06:46.950Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 38
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 39,
      uniqueId: '2b0c30cb-b9bc-4402-93b2-018aafa98eb5',
      createdAt: '2024-04-11T14:26:14.042Z',
      updatedAt: '2024-04-12T14:24:03.301Z',
      emailId: 'kitana20002002@yopmail.com',
      firstName: 'Lisa',
      lastName: 'Campbell',
      password: '12345678',
      phoneNumber: '7082751701',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-11T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: ' 043.126229',
      clinicalLicenseExpirationDate: '2028-06-30T14:23:46.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '11, South Spruce Lane, Glenwood, Bloom Township, Cook County, Illinois, United States, 60425, 1736',
      latitude: '41.5449821697085',
      longitude: '-87.6016094302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 155,
          createdAt: '2024-03-05T19:06:46.954Z',
          updatedAt: '2024-03-05T19:06:46.954Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 39
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 40,
      uniqueId: '25405344-d958-4c82-8d7c-a85f5e8b47fc',
      createdAt: '2024-04-16T18:31:39.697Z',
      updatedAt: '2024-04-21T22:33:31.314Z',
      emailId: 'jaypaddle@yopmail.com',
      firstName: 'Jay',
      lastName: 'Patel',
      password: '12345678',
      phoneNumber: '6303130617',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-463007',
      clinicalLicenseExpirationDate: '2028-04-07T18:30:01.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '5355, Shotkoski Drive, Hoffman Estates, Hanover Township, Cook County, Illinois, United States, 60192, 4149',
      latitude: '42.06358246970849',
      longitude: '-88.2144843302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 156,
          createdAt: '2024-03-05T19:06:46.971Z',
          updatedAt: '2024-03-05T19:06:46.971Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 40
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 41,
      uniqueId: '1eca31f4-c384-401c-b6ef-e56d4aaf9368',
      createdAt: '2024-04-16T18:35:17.679Z',
      updatedAt: '2024-04-20T15:21:45.711Z',
      emailId: 'murieldriscollusa@yopmail.com',
      firstName: 'Muriel',
      lastName: 'Driscoll',
      password: '12345678',
      phoneNumber: '8478948508',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-198058',
      clinicalLicenseExpirationDate: '2028-05-05T18:31:41.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '8216, Lawndale Avenue, Skokie, Niles Township, Cook County, Illinois, United States, 60076, 3324',
      latitude: '42.0291191197085',
      longitude: '-87.7222987302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 157,
          createdAt: '2024-03-05T19:06:46.994Z',
          updatedAt: '2024-03-05T19:06:46.994Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 41
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 43,
      uniqueId: 'f87b0d14-07cc-4229-9d8e-7bb894134a19',
      createdAt: '2024-04-16T18:39:28.107Z',
      updatedAt: '2024-07-11T03:01:22.515Z',
      emailId: 'nwaetteh2007@yopmail.com',
      firstName: 'Charles',
      lastName: 'Ndukew',
      password: '12345678',
      phoneNumber: '6093214605',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-520983',
      clinicalLicenseExpirationDate: '2028-02-02T19:36:59.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '766, East 5th Court, Des Plaines, Maine Township, Cook County, Illinois, United States, 60016, 3171',
      latitude: '42.0429404697085',
      longitude: '-87.90622153029152',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 160,
          createdAt: '2024-03-05T19:06:47.186Z',
          updatedAt: '2024-03-05T19:06:47.186Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 43
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 92,
      uniqueId: 'b4220001-4d5d-4613-ba1a-8d4885cc92c7',
      createdAt: '2024-07-11T20:22:43.989Z',
      updatedAt: '2024-07-15T12:54:16.604Z',
      emailId: 'cbrown90@yopmail.com',
      firstName: 'Coreene ',
      lastName: 'Mcgregor',
      password: '12345678',
      phoneNumber: '7732098993',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-07-11T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.370707',
      clinicalLicenseExpirationDate: '2024-07-11T20:21:13.963Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2345, Wyndham Court, Aurora, Naperville Township, DuPage County, Illinois, United States, 60504, 3240',
      latitude: '41.74140011970849',
      longitude: '-88.25929988029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 196,
          createdAt: '2024-05-20T11:39:17.148Z',
          updatedAt: '2024-05-20T11:39:17.148Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 92
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 49,
      uniqueId: 'a227e571-18b5-4424-a777-7562e4bb3736',
      createdAt: '2024-04-16T19:37:46.594Z',
      updatedAt: '2024-08-01T06:08:03.125Z',
      emailId: 'metute@yopmail.com',
      firstName: 'Meta',
      lastName: 'Trybyte',
      password: '12345678',
      phoneNumber: '6304423794',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-16T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-460457',
      clinicalLicenseExpirationDate: '2027-08-11T19:35:42.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1257, Camelot Lane, Lemont, Lemont Township, Cook County, Illinois, United States, 60439, 8503',
      latitude: '41.6591755197085',
      longitude: '-87.97569003029152',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 165,
          createdAt: '2024-03-05T19:06:47.388Z',
          updatedAt: '2024-03-05T19:06:47.388Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 49
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 91,
      uniqueId: '39904aab-4b50-4687-8ad9-d889612f2c0d',
      createdAt: '2024-06-21T14:43:30.881Z',
      updatedAt: '2024-09-26T19:27:43.925Z',
      emailId: 'jphansen973@yopmail.com',
      firstName: 'Jocelyn',
      lastName: 'Hansen',
      password: '12345678',
      phoneNumber: '7086916284',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-21T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'CNA',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: 'N/A',
      clinicalLicenseExpirationDate: '2027-06-11T14:41:16.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '10636, South Kenneth Avenue, Oak Lawn, Worth Township, Cook County, Illinois, United States, 60453, 5338',
      latitude: '41.69740136970849',
      longitude: '-87.73303313029149',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 195,
          createdAt: '2024-05-20T11:34:57.774Z',
          updatedAt: '2024-05-20T11:34:57.774Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 91
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 87,
      uniqueId: 'f98151fd-35d1-4c76-8f10-041c6a5b1e1d',
      createdAt: '2024-06-21T14:37:20.146Z',
      updatedAt: '2024-06-21T14:46:59.717Z',
      emailId: 'jesgaribo@yopmail.com',
      firstName: 'Jessica',
      lastName: 'Garibo',
      password: '12345678',
      phoneNumber: '2244778352',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-02T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.127135',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '202,915,North Countryside Drive,Palatine,Palatine Township,Cook County,Illinois,United States,60067',
      latitude: '42.1267979',
      longitude: '-88.07303',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 220,
          createdAt: '2024-03-05T19:06:47.186Z',
          updatedAt: '2024-03-05T19:06:47.186Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 87
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 89,
      uniqueId: '292c592a-c4b8-4827-9d47-43b01bbb5883',
      createdAt: '2024-06-21T14:37:20.139Z',
      updatedAt: '2024-06-21T14:37:20.139Z',
      emailId: 'mary_ann_laureano@yopmail.com',
      firstName: 'MaryAnn',
      lastName: 'Lauerano',
      password: '12345678',
      phoneNumber: '2243037173',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-02T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '43.106864',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1316,Arlington Circle,Hanover Park,Bloomingdale Township,DuPage County,Illinois,United States,60133,5517',
      latitude: '41.9677321',
      longitude: '-88.1358927',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 193,
          createdAt: '2024-05-20T11:28:58.749Z',
          updatedAt: '2024-05-20T11:28:58.749Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 89
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 44,
      uniqueId: 'f7faf662-f9ee-4086-87ee-9a663ac0006f',
      createdAt: '2024-04-16T18:41:35.394Z',
      updatedAt: '2024-04-17T17:45:27.554Z',
      emailId: 'ira.guenther@yopmail.com',
      firstName: 'Ira',
      lastName: 'Guenther',
      password: '12345678',
      phoneNumber: '8477780402',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: 'Fri Jul 03 1981 12:00:00 GMT-0500',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041-407173',
      clinicalLicenseExpirationDate: '2029-07-20T18:39:29.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '13200, West Heiden Circle, Lake Bluff, Libertyville Township, Lake County, Illinois, United States, 60044, 1056',
      latitude: '42.30008271970851',
      longitude: '-87.88923188029152',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 159,
          createdAt: '2024-03-05T19:06:47.184Z',
          updatedAt: '2024-03-05T19:06:47.184Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 44
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 54,
      uniqueId: 'baa98854-6c49-4522-a4bd-608bcd36f8cd',
      createdAt: '2024-04-20T01:09:15.229Z',
      updatedAt: '2024-05-14T15:04:46.181Z',
      emailId: 'donnayoung129@yopmail.com',
      firstName: 'Donna ',
      lastName: 'Young',
      password: '12345678',
      phoneNumber: '6303991204',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-04-19T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.291066',
      clinicalLicenseExpirationDate: '2027-06-12T01:07:12.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1119, Thelin Court, Batavia, Batavia Township, Kane County, Illinois, United States, 60510, 4545',
      latitude: '41.83200566970849',
      longitude: '-88.3284357302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 170,
          createdAt: '2024-03-05T19:27:47.516Z',
          updatedAt: '2024-03-05T19:27:47.516Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 54
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 66,
      uniqueId: 'd0a8fac9-3967-4e85-bf28-fe7e7611b0bf',
      createdAt: '2024-06-05T03:27:09.973Z',
      updatedAt: '2024-06-05T03:27:24.285Z',
      emailId: 'artistapples@yopmail.com',
      firstName: 'Artist ',
      lastName: 'Grayson-Houston',
      password: '12345678',
      phoneNumber: '7739108220',
      gender: 'Male',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.443013',
      clinicalLicenseExpirationDate: '2026-06-25T03:25:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1175, Janice Drive, Sauk Village, Bloom Township, Cook County, Illinois, United States, 60411, 5085',
      latitude: '41.4826450697085',
      longitude: '-87.5903629302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 177,
          createdAt: '2024-04-16T18:35:17.725Z',
          updatedAt: '2024-04-16T18:35:17.725Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 66
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 67,
      uniqueId: '78dee67e-027d-4191-bff7-1ccb0bb014cb',
      createdAt: '2024-06-05T03:30:17.314Z',
      updatedAt: '2024-06-18T20:12:42.367Z',
      emailId: 'chinelogn@yopmail.com',
      firstName: 'Chinelo',
      lastName: 'Ike',
      password: '12345678',
      phoneNumber: '7732001786',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.460563',
      clinicalLicenseExpirationDate: '2024-06-05T03:29:04.734Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '7534, North Claremont Avenue, Chicago, , Cook County, Illinois, United States, 60645, 1502',
      latitude: '42.01720041970851',
      longitude: '-87.69064683029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 178,
          createdAt: '2024-04-16T18:36:48.519Z',
          updatedAt: '2024-04-23T13:02:25.116Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening'],
          minDistance: '1',
          maxDistance: '49',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 67
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 73,
      uniqueId: '4e59cfe4-f73d-4ebc-863e-f506f48ef413',
      createdAt: '2024-06-05T03:40:06.854Z',
      updatedAt: '2024-06-05T03:40:06.854Z',
      emailId: 'hbahenalpn09@yopmail.com',
      firstName: 'Herlinda',
      lastName: 'Bahena',
      password: '12345678',
      phoneNumber: '7732093245',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.111219',
      clinicalLicenseExpirationDate: '2024-06-05T03:38:52.958Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '9054, Martin Lane, Bridgeview, Worth Township, Cook County, Illinois, United States, 60455, 2023',
      latitude: '41.72545271970849',
      longitude: '-87.79897193029149',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 183,
          createdAt: '2024-04-16T19:34:32.316Z',
          updatedAt: '2024-04-16T19:34:32.316Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 73
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 74,
      uniqueId: 'e8a4975d-66c4-4253-b4b3-aafe03fe59b1',
      createdAt: '2024-06-05T03:41:40.595Z',
      updatedAt: '2024-06-14T16:16:35.753Z',
      emailId: 'jparker981@yopmail.com',
      firstName: 'Joyce',
      lastName: 'Reliford-Parker',
      password: '12345678',
      phoneNumber: '8157241219',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.323253',
      clinicalLicenseExpirationDate: '2024-06-05T03:40:15.070Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1219, Cherry Hill Road, Joliet, Joliet Township, Will County, Illinois, United States, 60433, 8580',
      latitude: '41.4996116197085',
      longitude: '-88.0248421802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 184,
          createdAt: '2024-04-16T19:35:40.866Z',
          updatedAt: '2024-04-16T19:35:40.866Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 74
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 75,
      uniqueId: 'd1c5614f-d3f0-434b-9fce-abbd8eafeb8a',
      createdAt: '2024-06-05T03:42:48.176Z',
      updatedAt: '2024-06-05T03:42:48.176Z',
      emailId: 'eisaknapp@yopmail.com',
      firstName: 'Leisa',
      lastName: 'Knapp',
      password: '12345678',
      phoneNumber: '7797021625',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.450001',
      clinicalLicenseExpirationDate: '2024-06-05T03:41:41.835Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '1310, East Southmor Road, Morris, Wauponsee Township, Grundy County, Illinois, United States, 60450, 8441',
      latitude: '41.3352055197085',
      longitude: '-88.39724533029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 185,
          createdAt: '2024-04-16T19:37:46.638Z',
          updatedAt: '2024-04-16T19:37:46.638Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 75
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 76,
      uniqueId: '572682e7-f183-480d-ab4d-fe2b0b44a7d6',
      createdAt: '2024-06-05T03:46:13.516Z',
      updatedAt: '2024-06-13T21:08:09.819Z',
      emailId: 'mishellfreire@yopmail.com',
      firstName: 'Mishelle',
      lastName: 'Freire',
      password: '12345678',
      phoneNumber: '6308279449',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.539570',
      clinicalLicenseExpirationDate: '2024-06-05T03:42:49.373Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2N333, Pearl Avenue, Glen Ellyn, Bloomingdale Township, DuPage County, Illinois, United States, 60137, ',
      latitude: '41.9080124197085',
      longitude: '-88.07283633029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 186,
          createdAt: '2024-04-16T19:38:58.089Z',
          updatedAt: '2024-04-16T19:38:58.089Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 76
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 80,
      uniqueId: '18cd5496-0806-4a63-a7b4-37ad3a6ba7b0',
      createdAt: '2024-06-05T03:54:18.382Z',
      updatedAt: '2024-06-13T22:06:26.903Z',
      emailId: 'msrodriguez3@yopmail.com',
      firstName: 'Sandra',
      lastName: 'Rodriquez',
      password: '12345678',
      phoneNumber: '7082991630',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '041.459230',
      clinicalLicenseExpirationDate: 'Sun May 31 2026 12:00:00 GMT-0500',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: ['Medical / Surgical', 'Home Health', 'Case Management'],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '37, West Hickory Street, Chicago Heights, Bloom Township, Cook County, Illinois, United States, 60411, 4058',
      latitude: '41.49838331970849',
      longitude: '-87.64336093029151',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 188,
          createdAt: '2024-04-16T19:43:49.762Z',
          updatedAt: '2024-04-16T19:43:49.762Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 80
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 81,
      uniqueId: '01c12037-42b6-46f6-ad9f-e833ea0eee7c',
      createdAt: '2024-06-05T03:55:21.002Z',
      updatedAt: '2024-06-05T03:55:21.002Z',
      emailId: 'shonitagates@yopmail.com',
      firstName: 'Shonita ',
      lastName: 'Gates',
      password: '12345678',
      phoneNumber: '3125231923',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.129934',
      clinicalLicenseExpirationDate: '2024-06-05T03:54:19.723Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '5901, South Francisco Avenue, Chicago, , Cook County, Illinois, United States, 60629, ',
      latitude: '41.7848606197085',
      longitude: '-87.6972746802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 189,
          createdAt: '2024-04-20T01:07:11.306Z',
          updatedAt: '2024-04-20T01:07:11.306Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 81
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 82,
      uniqueId: '50bea1e4-1c0b-44a6-974b-3b12a888526a',
      createdAt: '2024-06-05T03:56:19.758Z',
      updatedAt: '2024-06-05T03:56:19.758Z',
      emailId: 'tenisonjwilliams@yopmail.com',
      firstName: 'Tenison',
      lastName: 'Williams',
      password: '12345678',
      phoneNumber: '3123206136',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-04T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.123728',
      clinicalLicenseExpirationDate: '2024-06-05T03:55:22.138Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '2830, Brian Lane, Montgomery, Bristol Township, Kendall County, Illinois, United States, 60538, 5100',
      latitude: '41.7203592697085',
      longitude: '-88.4016384802915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 190,
          createdAt: '2024-04-20T01:09:15.283Z',
          updatedAt: '2024-04-20T01:09:15.283Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 82
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 84,
      uniqueId: 'b177128f-c22f-44d2-a713-112721ce613b',
      createdAt: '2024-06-05T17:42:09.440Z',
      updatedAt: '2024-06-05T17:42:09.440Z',
      emailId: 'ispiff74@yopmail.com',
      firstName: 'Inayeba',
      lastName: 'Spiff',
      password: '12345678',
      phoneNumber: '7739576926',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2006-06-05T05:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'LPN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '043.111075',
      clinicalLicenseExpirationDate: '2024-06-05T17:40:33.452Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '8836, South Wabash Avenue, Chicago, , Cook County, Illinois, United States, 60619, 6615',
      latitude: '41.7321416697085',
      longitude: '-87.6240526302915',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 192,
          createdAt: '2024-05-08T11:28:31.960Z',
          updatedAt: '2024-05-08T11:28:31.960Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 84
        }
      ],
      ReferencesDetailNurse: []
    },
    {
      id: 85,
      uniqueId: 'd0743d94-7d94-42a6-9d84-a087daefb731',
      createdAt: '2024-06-21T14:37:20.053Z',
      updatedAt: '2024-07-31T15:41:21.448Z',
      emailId: 'smirnovao@yopmail.com',
      firstName: 'Olga',
      lastName: 'Orosciuc',
      password: '12345678',
      phoneNumber: '7088058391',
      gender: 'Female',
      profileImage: '',
      mobileId: '',
      dateOfBirth: '2000-01-02T00:00:00.000Z',
      primaryState: 'Illinois',
      primaryLicenseType: 'RN',
      primaryLicenseMultiPrivilege: false,
      clinicalLicenseNumber: '41.419466',
      clinicalLicenseExpirationDate: '2027-01-22T00:00:00.000Z',
      registeredWithAn: '',
      employeeId: '',
      employeeName: '',
      specialty: [],
      certificationDetails: [],
      educationDetails: [],
      skills: [],
      EMRorEHRExperience: [],
      workExperienceDetails: [],
      uploadDocuments: [],
      fullAddress:
        '295,Woodstone Circle,Buffalo Grove,Vernon Township,Lake County,Illinois,United States,60089,6702',
      latitude: '42.1572097',
      longitude: '-87.9565648',
      currentLatitude: '',
      currentLongitude: '',
      organization: 'NURSD Health',
      location_id: 'Chicago60540',
      nurseVerified: true,
      emailVerified: true,
      nurseLoginControl: true,
      nurseAppAccessControl: false,
      JobPreferencesNurse: [
        {
          id: 218,
          createdAt: '2024-03-05T19:06:47.024Z',
          updatedAt: '2024-03-05T19:06:47.024Z',
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          duration: [],
          timing: ['Morning', 'Afternoon', 'Evening', 'Night'],
          minDistance: '1',
          maxDistance: '100',
          minRate: '1',
          maxRate: '100',
          notLicensedStateHideJobs: true,
          showJobs: 'Both',
          preferenceOption: true,
          additionalFields: [],
          preStateAdditionalFields: [],
          nurseTableID: 85
        }
      ],
      ReferencesDetailNurse: []
    }
  ]
};
